import React, { useContext, useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import $ from "jquery";
import OrgContext from "../../organisation/OrgContext";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {
  getEcEco,
  getEcEcoV2,
  getEcFin,
  getPieceEc,
  getPieceLier,
  getPieceLierV2,
} from "../../helpers/EcritureComptableHeper";
import axios from "axios";
import { baseURL } from "../../services/api";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import ReactPDF from "@react-pdf/renderer";
import { PDFDownloadLink } from "@react-pdf/renderer";

import { frFR, enUS } from "@mui/x-data-grid";
import { LinearProgress } from "@mui/material";
import { formatNumber } from "../../helpers/formater";
import {
  etatStockColumns,
  exportEc,
  exportJr,
  exportStockState,
} from "../../helpers/ExportCsvHelper";
import useAuthHelper from "../../helpers/AuthHelper";
import GoBack from "../../components/goBack";

const Journal = () => {
  const [currentYear,setCurrentYear] =useState(new Date().getFullYear());
  const { organisation } = useContext(OrgContext);
  const [invoices, setInvoices] = useState([]);
  const [pieces, setPieces] = useState([]);
  const [months, setMonths] = useState([]);
  const [staticInvoices, setStaticInvoices] = useState([]);
  const [filterOption, setFilterOption] = useState("");
  const [chooseMonth, setChooseMonth] = useState(0);
  const [concernedInvoices, setConcernedInvoices] = useState([]);
  const [invoicesEcs, setInvoicesEcs] = useState([]);
  const [invoicesEcsFf, setInvoicesEcsFf] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [t, i18n] = useTranslation();
  const [ecsLoaded, setEcsLoaded] = useState(0);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const showInvoiceNumberColumn = ["FA", "FV"].includes(filterOption);
  const [bqAccountId, setBqAccountId] = useState(0);
  const [caisseAccountId, setCaisseAccountId] = useState("");
  const [notEmpty, setNotEmpty] = useState(1);
  const [loadingData, setLoadingData] = useState(false);

  const [selectedMonths, setSelectedMonths] = useState([]);
  const [invsDataFiltered, setInvsDataFiltered] = useState(null);
  const [selectedExportType, setSelectedExportType] = useState(null);
  const [exportCsv, setExportCsv] = useState(false);
  const [msgErrorDate, setMsgErrorDate] = useState("");
  const [proccesing, setProccessing] = useState(false);
  const [loaded, setLoaded] = useState(false);

  // sous compte comptable des paiement
  const [sousCompte, setSousCompte] = useState("");
  const [sousComptes, setSousComptes] = useState([]);
  const [sousComptesCs, setSousComptesCs] = useState([]);
  const [getBqSousCompte, setGetBqSousCompte] = useState(false);
  const [getCsSousCompte, setGetCsSousCompte] = useState(false);
  const [allBqAccounts, setAllBqAccounts] = useState([]);
  const [allCsAccounts, setAllCsAccounts] = useState([]);
  const selectRef = useRef(null);
  const selectRefSousCompte = useRef(null);
  const {onlyComptable} = useAuthHelper();

  useEffect(() => {
    onlyComptable();
    if (organisation.id) {
      getMonths();
      getAllInvoices();
      getAllPieces();
      getAccounts();
      fetchSousAccounts();
      fetchSousAccountsCs();
    }
  }, []);

  /**
   *
   * @return {Promise<void>}
   */
  const fetchSousAccounts = async () => {
    await jwtInterceoptor
      .get("/data/user/bq/accounts/" + organisation.id)
      .then((res) => {
        setSousComptes(res.data.data);
        getAllBqAccounts(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   *
   * @return {Promise<void>}
   */
  const fetchSousAccountsCs = async () => {
    await jwtInterceoptor
        .get("/data/user/cs/accounts/" + organisation.id)
        .then((res) => {
          setSousComptesCs(res.data.data);
          getAllCsAccounts(res.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
  };

  const clearSelection = () => {
    if (selectRef.current) {
      selectRef.current.value = "all";
    }
    setSousCompte("");
  };

  /**
   *
   * @param accounts
   */
  const getAllBqAccounts = (accounts) => {
    /**
     *
     * @type {*[]}
     */
    let bqAccounts = [];

    for (let i = 0; i < accounts.length; i++) {
      bqAccounts.push(accounts[i].code);
    }

    setAllBqAccounts(bqAccounts);
  };

  const getAllCsAccounts = (accounts) => {
    /**
     *
     * @type {*[]}
     */
    let csAccounts = [];

    for (let i = 0; i < accounts.length; i++) {
      csAccounts.push(accounts[i].code);
    }

    setAllCsAccounts(csAccounts);
  };

  const getAccounts = async () => {
    await axios
      .get(baseURL + "/paymentAccounts")
      .then((response) => {
        response.data.data.map((a) => {
          console.log("Accounts are : ", response.data.data);
          if (a.name === "Banques (soldes débiteurs)") {
            setBqAccountId(a.code);
          } else if (a.name === "Caisses") {
            setCaisseAccountId(a.code);
          }
        });
      })
      .catch((error) =>
        console.log("error while retrieving setBanqueAccounts : " + error)
      );
  };
  useEffect(() => {
    console.log("i18n: ", i18n.language);
  }, [i18n]);
  const getMonths = async () => {
    setLoadingData(true);
    const response = await jwtInterceoptor.get(`/data/months`);
    if (response.status !== 200) {
      return;
    }
    let months = response.data.data.map((m) => {
      if (m.code < 10) {
        m.code = "0" + m.code;
        return m;
      }
      return m;
    });
    setMonths(months);
    setLoadingData(false);
  };

  useEffect(() => {
    console.log("*******************");
    console.log("sousCompte: ", sousCompte);
    console.log("*******************");
    /**
     * is it or not sous compte de la bq ou la caisse
     * @type {boolean}
     */
    let isPaymentSousCompte = false;
    let isEmpty = 1;
    let lesFactures = [];
    setNotEmpty(0);
    setInvoicesEcs([]);
    setInvoicesEcsFf([]);
    setEcsLoaded(0);
    setTotalCredit(0);
    setTotalDebit(0);

    console.log("OPTION: ", filterOption);
    let lesEcrtituresCOmptable = [];
    // isPaymentSousCompte = !['all', '', 'OD', 'RAN', 'CS','FA', 'FV'].includes(filterOption);
    // //empty bq/sousCompteBq
    // if(isPaymentSousCompte===false){
    //     setSousCompte('');
    //     setGetBqSousCompte(false);
    // }

    if (["FA", "FV"].includes(filterOption)) {
      setEcsLoaded(1);
      invoices.map((invoice) => {
        if (
          moment(invoice.created_at).format("MM") === chooseMonth.toString() && moment(invoice.created_at).format("YYYY") === currentYear.toString() &&
          getCodeCores(filterOption).includes(invoice.type)
        ) {
          isEmpty = 0;
          setNotEmpty(1);
          setInvoicesEcs((invoicesEcs) => [
            ...invoicesEcs,
            getEcEcoV2(invoice),
          ]);

          if (getPieceLierV2(invoice) !== null) {
            setInvoicesEcs((invoicesEcs) => [
              ...invoicesEcs,
              getPieceLierV2(invoice),
            ]);
          }
        }
      });

      if (isEmpty === 1) {
        setEcsLoaded(1);
        toast.warning(t("Aucun element durant ce mois"), {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      setEcsLoaded(0);
    } else if (
      ["BQ", "CS", "ALLBQ","ALLCS"].includes(filterOption) ||
      isBqSousCompte(filterOption) || isCsSousCompte(filterOption)
    ) {

      //get journal from invoice's transaction
      invoices.filter((invoice) => {
        let payedAmounts = 0;
        let letTotalhtFluxFin = 0;
        let le_compte_fournisseur = "";
        let invoice_type = "";
        let total_ttc = 0;
        let conditionBq = false;

        for (let i = 0; i < invoice.payment.length; i++) {
          if ([2, 3].includes(invoice.payment[i].status.id)) {
            payedAmounts += parseFloat(invoice.payment[i].payed_amount);

            setEcsLoaded(1);

            if (sousCompte === "allSousCompteBq") {
              conditionBq =
                moment(invoice.payment[i].created_at).format("MM") ===
                  chooseMonth.toString() && moment(invoice.payment[i].created_at).format("YYYY") ===
                  currentYear.toString() &&
                isBqSousCompte(invoice.payment[i].payment_account.code);
            }else if (sousCompte === "allSousCompteCs") {
              conditionBq =
                  moment(invoice.payment[i].created_at).format("MM") ===
                  chooseMonth.toString() &&
                  moment(invoice.payment[i].created_at).format("YYYY") ===
                  currentYear.toString()
              &&
                  isCsSousCompte(invoice.payment[i].payment_account.code);
            } else {
              conditionBq =
                moment(invoice.payment[i].created_at).format("MM") ===
                  chooseMonth.toString() &&
                  moment(invoice.payment[i].created_at).format("YYYY") ===
                  currentYear.toString() &&
                invoice.payment[i].payment_account.code ===
                  getCodeCores(filterOption);
            }

            if (conditionBq) {
              // rendre les mnt négative si facture d'avoir
              let operator = 0;

              if (i === 0 && invoice.payment[i].status.id === 2) {
                letTotalhtFluxFin = invoice.total_ttc;
              } else if (i > 0 && invoice.payment[i].status.id === 2) {
                //condition 2, is paid from the x iteration
                letTotalhtFluxFin =
                  parseFloat(invoice.total_ttc) - payedAmounts;
              } else {
                //condition 3, if not paid yet
                letTotalhtFluxFin = invoice.payment[i].payed_amount;
              }

              if (invoice.type === "achat") {
                operator = 1;
                total_ttc = invoice.total_ttc;
                invoice_type = "achat";
                le_compte_fournisseur = "4411000";
              } else if (invoice.type === "vente" || invoice.type === "avoir") {
                operator = invoice.type === "avoir" ? -1 : 1;
                total_ttc = invoice.total_ttc;
                invoice_type = "vente";
                le_compte_fournisseur = "34210000";
              } else if (invoice.type === "depense") {
                operator = 1;
                total_ttc = invoice.total_ttc;
                invoice_type = "depense";
                le_compte_fournisseur = "4411000";
              }

              console.log("okokokokokok");
              setEcsLoaded(1);
              setNotEmpty(1);
              isEmpty = 0;
              let elt = {
                date_creation: moment(invoice.payment[i].created_at).format(
                  "DD/MM/YYYY"
                ),
                no_piece:
                  invoice.type === "avoir"
                    ? "FAV" + "" + invoice.id
                    : invoice.type.charAt(0) + "" + invoice.id,
                compte_fournisseur: le_compte_fournisseur,
                sous_compte: invoice.client.account.code,
                payment_account: invoice.payment[i].payment_account.code,
                banquePaymentOption: invoice.payment[i].banquePaymentOption,
                chequeId: invoice.payment[i].chequeId,
                libelle_fournisseur: invoice.client.companyName,
                invoice_type: invoice_type,
                total_ttc: Number(letTotalhtFluxFin).toFixed(2) * operator,
              };
              setInvoicesEcsFf((invoicesEcsFf) => [...invoicesEcsFf, elt]);
            }
          }
        }
      });

      //then get it from piece's transaction
      pieces.filter((piece) => {
        if (piece['debit_credit'][0]["account"]["code"] === filterOption.toString()) {
          if (
              moment(piece.created_at).format("MM") === chooseMonth.toString() && moment(piece.created_at).format("YYYY") === currentYear.toString()
          ) {
            isEmpty = 0;
            setNotEmpty(1);
            let flux = getPieceEc(piece, true);
            if (flux != null) {
              setInvoicesEcsFf((invoicesEcsFf) => [...invoicesEcsFf, flux]);
            }
          }
        } else if (filterOption === "ALLBQ" && isBqSousCompte(piece['debit_credit'][0]["account"]["code"])) {
          if (
              moment(piece.created_at).format("MM") === chooseMonth.toString() && moment(piece.created_at).format("YYYY") === currentYear.toString()
          ) {
            isEmpty = 0;
            setNotEmpty(1);
            let flux = getPieceEc(piece, true);
            if (flux != null) {
              setInvoicesEcsFf((invoicesEcsFf) => [...invoicesEcsFf, flux]);
            }
          }
        } else if (filterOption === "ALLCS" && isCsSousCompte(piece['debit_credit'][0]["account"]["code"])) {
          if (
              moment(piece.created_at).format("MM") === chooseMonth.toString() && moment(piece.created_at).format("YYYY") === currentYear.toString()
          ) {
            isEmpty = 0;
            setNotEmpty(1);
            let flux = getPieceEc(piece, true);
            if (flux != null) {
              setInvoicesEcsFf((invoicesEcsFf) => [...invoicesEcsFf, flux]);
            }
          }
        }
      });

      if (isEmpty === 1) {
        console.log("filterOption ", filterOption);
        console.log("isEmpty ", isEmpty);
        console.log("here********* ");
        toast.warning(t("Aucune transaction durant ce mois"), {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }

      setEcsLoaded(0);
    } else if (["RAN", "OD"].includes(filterOption)) {
      setEcsLoaded(1);
      lesFactures = pieces.filter((piece) => {
        if (piece.journal === getCodeCores(filterOption)) {
          if (
            moment(piece.created_at).format("MM") === chooseMonth.toString() && moment(piece.created_at).format("YYYY") === currentYear.toString()
          ) {
            isEmpty = 0;
            setNotEmpty(1);
            let flux = getPieceEc(piece);
            if (flux != null) {
              setInvoicesEcs((invoicesEcs) => [...invoicesEcs, flux]);
            }
          }
          console.log("invoicesEcsFf X : ", invoicesEcsFf);
        }
      });
      if (isEmpty === 1) {
        console.log("filterOption ", filterOption);
        console.log("isEmpty ", isEmpty);
        toast.warning(t("Aucune transaction durant ce mois"), {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      setEcsLoaded(0);
    } else if (filterOption === "all") {
      //setEcsLoaded(1);
    }
  }, [filterOption]);
  const getCodeCores = (code) => {
    if (code === "FV") {
      return ["vente", "avoir"];
    } else if (code === "FA") {
      return ["achat", "depense"];
    } else if (code === "BQ") {
      return bqAccountId.toString();
    } else if (code === "CS") {
      return caisseAccountId.toString();
    } else if (code === "RAN") {
      return "Report à Nouveaux";
    } else if (code === "OD") {
      return "Operation Diverses";
    } else {
      if (code !== "" && code != null) {
        return code;
      }
    }
  };

  /**
   *
   * @param code
   * @return {boolean}
   */
  const isBqSousCompte = (code) => {
    console.log("code : ",code);
    return code.substring(0, 4) === "5141";
  };

  /**
   *
   * @param code
   * @return {boolean}
   */
  const isCsSousCompte = (code) => {
    return code.substring(0, 4) === "5161";
  };

  const getAllInvoices = async () => {
    setInvoices([]);
    const response = await jwtInterceoptor.get(
      `/data/user/factures/getinvoicesforjr/${organisation.id}`
    );

    if (response.status === 200) {
      setInvoices(response.data.data);
      setStaticInvoices(response.data.data);
      console.log("invodsdsdcies: ", response.data.data);
    }
  };

  const getAllPieces = async () => {
    setInvoices([]);
    const response = await jwtInterceoptor.get(
      `/data/user/piece/get/${organisation.id}`
    );

    if (response.status === 200) {
      console.log("les piéces : ", response.data.data);
      setPieces(response.data.data);
    }
  };

  const columns = [
    {
      field: "Mois",
      headerName: t("Mois"),
      valueGetter: (params) =>
        i18n.language === "fr" ? params.row.name_fr+'/'+currentYear : params.row.name_eng+'/'+currentYear,
      width: 300,
    },
    {
      flex: 1,
      field: "Action",
      headerName: t(""),
      renderCell: (params) => {
        return (
          <div className="btn-list">
            <a
              id="bEdit"
              className="btn  btn-sm btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#exampleModalFullscreen"
              style={{ color: "white" }}
              onClick={() => {
                setInvoicesEcsFf([])
                setInvoicesEcs([])

                setSousCompte("");
                setGetBqSousCompte(false);
                setFilterOption("");
                $("#warningBlockToSelectElement").css("display", "none");
                setChooseMonth(params.row.code);
                toast.info(t("Merci de sélectionner un critére de recherche"), {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                });

                window.$("#exampleModalFullscreen").modal("hide");
              }}
            >
              <span className="fe fe-eye"> </span>
            </a>
          </div>
        );
      },
    },
  ];

  // Create styles
  const styles = StyleSheet.create({
    page: {
      // flexDirection: 'row',
      // backgroundColor: '#E4E4E4'
    },
    section: {
      margin: 10,
      padding: 10,
      fontSize: 11,
      //flex: 1,
      // flexGrow: 1,
    },
    header: {
      flexDirection: "row",
      marginBottom: 12,
      borderWidth: 1,
    },
    cell: {
      borderRightWidth: 1,
      justifyContent: "center",
      alignItems: "center",
      minHeight: 25,
    },
    cellRow: {
      minHeight: 25,
      padding: 5,
      paddingTop: 7,
    },
    textHeader: {
      fontSize: 10.5,
      fontWeight: "bold",
    },
    row: {
      flexDirection: "row",
    },
    textRow: {
      fontSize: 9.5,
    },
    headerPage: {
      flexDirection: "row",
      padding: 5,
      borderWidth: 1.5,
      marginBottom: 5,
    },
    leftSide: {
      flex: 1,
      justifyContent: "space-between",
    },
    centerContainer: {
      flex: 1,
      justifyContent: "space-between",
      alignItems: "center",
    },
    rightSide: {
      flex: 1,
      justifyContent: "flex-end",
    },
  });

  const refPagePdf = useRef(null);

  useEffect(() => {
    console.log("test");
  }, [refPagePdf?.current?.clientHeight]);

  /**
   *
   * @param data FV (fe)
   * @param data2 BQ (ff)
   * @param codeFacture BANQUE,VENTES
   * @param subCodeFC BQ,VTE
   * @return {JSX.Element}
   * @constructor
   */
  const JournalPDF = ({
    data = [],
    data2 = [],
    codeFacture = "",
    subCodeFC = "",
  }) => {
    //data = data.concat(data);
    let total_debit = 0;
    let total_credit = 0;
    let month = null;
    let indexMonth = months.findIndex((m) => m.code === chooseMonth);
    if (indexMonth > -1) {
      month = months[indexMonth];
    }
    let date_now = new Date();
    let copyIcon = " © ";
    const onLayout = (event) => {
      const { x, y, height, width } = event.nativeEvent.layout;
      console.log("view height", height);
    };
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            <View style={styles.headerPage}>
              <View style={styles.leftSide}>
                <Text>{organisation?.name}</Text>
                <Text>Impression provisoire</Text>
              </View>
              <View style={styles.centerContainer}>
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 18,
                    fontWeight: "bold",
                    marginBottom: 6,
                  }}
                >
                  Journal
                </Text>
                <View style={{ flexDirection: "row" }}>
                  <Text style={{ marginRight: 30, fontSize: 11.5 }}>
                    {subCodeFC}
                  </Text>
                  <Text style={{ fontSize: 11.5 }}>{codeFacture}</Text>
                </View>
              </View>
              <View style={styles.rightSide}>
                <View
                  style={{ flexDirection: "row", justifyContent: "flex-end" }}
                >
                  <Text style={{ textAlign: "right", marginRight: 4 }}>
                    Tenue de compte :{" "}
                  </Text>
                  <Text style={{ textAlign: "right" }}>
                    {month?.name_fr}
                    {/*{date_now?.getFullYear()}*/}
                  </Text>
                </View>
              </View>
            </View>
            <View style={[styles.headerPage, { border: 0, padding: 0 }]}>
              <View style={styles.leftSide}>
                <Text style={{ fontSize: 9 }}>
                  {copyIcon}
                  <Text style={{ htmlContnet: "\\00A9" }}></Text>
                  {"ELMANAGER COMMERCIALISATION ET COMPTABILITE"}
                </Text>
              </View>
              <View style={[{ justifyContent: "flex-end" }]}>
                <View style={{ flexDirection: "row", alignItems: "flex-end" }}>
                  <Text style={{ textAlign: "right", marginRight: 4 }}>
                    Date de tirage :{" "}
                  </Text>
                  <Text style={{ textAlign: "right" }}>
                    {date_now?.getDate()}/{date_now?.getMonth() + 1}/
                    {date_now?.getFullYear()} à {date_now?.getUTCHours() + 1}:
                    {date_now?.getMinutes() < 10
                      ? "0" + date_now?.getMinutes()
                      : date_now?.getMinutes()}
                  </Text>
                </View>
              </View>
            </View>
            <View style={styles.header}>
              <View style={[styles.cell, { flex: 2 }]}>
                <Text style={styles.textHeader}>Jour</Text>
              </View>
              <View style={[styles.cell, { flex: 2 }]}>
                <Text style={styles.textHeader}>N° pièce</Text>
              </View>
              <View style={[styles.cell, { flex: 2 }]}>
                <Text style={styles.textHeader}>N° compte</Text>
              </View>
              <View style={[styles.cell, { flex: 3 }]}>
                <Text style={styles.textHeader}>N° tiers</Text>
              </View>
              <View style={[styles.cell, { flex: 3 }]}>
                <Text style={styles.textHeader}>Libellé écriture</Text>
              </View>
              <View style={[styles.cell, { flex: 3 }]}>
                <Text style={styles.textHeader}>Mvts débit</Text>
              </View>
              <View style={[styles.cell, { flex: 3, borderRightWidth: 0 }]}>
                <Text>Mvts crédit</Text>
              </View>
            </View>
            <View ref={refPagePdf} onLayout={onLayout} style={{ border: 1 }}>
              {data.map((flux) => {
                console.log(flux);
                if (flux.from === "invoice_module") {
                  total_credit += parseFloat(flux.total_ttc);
                  console.log(flux?.total_ht_et_tva);
                  return (
                    <View style={styles.row}>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>{flux.date_creation}</Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>{flux.no_piece}</Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>
                          {flux.compte_fournisseur}
                        </Text>
                        {flux.compte_tva?.map((tva) => {
                          return <Text style={styles.textRow}>{tva}</Text>;
                        })}
                        {flux?.compte_compte_de_charge?.map(
                          (compte_de_charge) => {
                            return (
                              <Text style={styles.textRow}>
                                {compte_de_charge}
                              </Text>
                            );
                          }
                        )}
                      </View>
                      <View style={[styles.cellRow, { flex: 3 }]}>
                        <Text style={styles.textRow}>{flux.sous_compte}</Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 3 }]}>
                        <Text style={styles.textRow}>
                          {flux.libelle_fournisseur}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 3, borderLeftWidth: 1 },
                        ]}
                      >
                        {flux.invoice_type === "vente" ? (
                          <Text
                            style={[styles.textRow, { textAlign: "right" }]}
                          >
                            {Number(flux.total_ttc).toFixed(2)}
                          </Text>
                        ) : (
                          flux?.total_ht_et_tva?.map(
                            (total_ht_et_tva, elt = 0) => {
                              total_debit +=
                                total_ht_et_tva != "<br />"
                                  ? total_ht_et_tva
                                  : 0;
                              console.log(total_ht_et_tva);
                              if (elt === 0) {
                                elt++;
                                return (
                                  <Text
                                    style={[
                                      styles.textRow,
                                      { textAlign: "right" },
                                    ]}
                                  >
                                    {"\n"}
                                  </Text>
                                );
                              }
                              return (
                                <Text
                                  style={[
                                    styles.textRow,
                                    { textAlign: "right" },
                                  ]}
                                >
                                  {Number(total_ht_et_tva).toFixed(2)}
                                </Text>
                              );
                            }
                          )
                        )}
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 3, borderLeftWidth: 1 },
                        ]}
                      >
                        {flux.invoice_type === "vente" ? (
                          flux?.total_ht_et_tva?.map(
                            (total_ht_et_tva, elt = 0) => {
                              total_debit +=
                                total_ht_et_tva != "<br />"
                                  ? total_ht_et_tva
                                  : 0;
                              if (elt === 0) {
                                elt++;
                                return (
                                  <Text
                                    style={[
                                      styles.textRow,
                                      { textAlign: "right" },
                                    ]}
                                  >
                                    {"\n"}
                                  </Text>
                                );
                              }
                              return (
                                <Text
                                  style={[
                                    styles.textRow,
                                    { textAlign: "right" },
                                  ]}
                                >
                                  {Number(total_ht_et_tva).toFixed(2)}
                                </Text>
                              );
                            }
                          )
                        ) : (
                          <Text
                            style={[styles.textRow, { textAlign: "right" }]}
                          >
                            {Number(flux.total_ttc).toFixed(2)}
                          </Text>
                        )}
                      </View>
                    </View>
                  );
                } else {
                  flux.debit &&
                    flux.debit[0].map((c) => {
                      total_debit += parseFloat(c);
                    });
                  flux.credit &&
                    flux.credit[0].map((c) => {
                      total_credit += parseFloat(c);
                    });
                  return (
                    <View style={styles.row}>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>{flux.date_creation}</Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>{flux.no_piece}</Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>
                          {flux.compte_fournisseur}
                        </Text>

                        {flux.accounts &&
                          flux.accounts[0].map((account) => {
                            return (
                              <Text style={styles.textRow}>{account}</Text>
                            );
                          })}

                      </View>
                      <View style={[styles.cellRow, { flex: 3 }]}>
                        <Text style={styles.textRow}>{"-"}</Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 3 }]}>
                        <Text style={styles.textRow}>
                          {flux.libelle_fournisseur}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 3, borderLeftWidth: 1 },
                        ]}
                      >
                        {flux.from === "ocr_ec_module" ? (
                          <Text style={styles.textRow}>{"\n"}</Text>
                        ) : null}
                        {flux.debit &&
                          flux.debit[0].map((d) => {
                            return (
                              <Text
                                style={[styles.textRow, { textAlign: "right" }]}
                              >
                                {Number(d).toFixed(2)}
                              </Text>
                            );
                          })}
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 3, borderLeftWidth: 1 },
                        ]}
                      >
                        {flux.from === "ocr_ec_module" ? (
                          <Text style={styles.textRow}>{"\n"}</Text>
                        ) : null}
                        {flux.credit &&
                          flux.credit[0].map((c) => {
                            return (
                              <Text
                                style={[styles.textRow, { textAlign: "right" }]}
                              >
                                {Number(c).toFixed(2)}
                              </Text>
                            );
                          })}
                      </View>
                    </View>
                  );
                }
              })}
              {data2.map((f) => {
                if(f.isSousCompteBqCs){

                  f.debit &&
                  f.debit[0].map((c) => {
                    total_debit += parseFloat(c);
                  });
                  f.credit &&
                  f.credit[0].map((c) => {
                    total_credit += parseFloat(c);
                  });

                  return (
                      <View style={styles.row}>
                        <View style={[styles.cellRow, { flex: 2 }]}>
                          <Text style={styles.textRow}>{f.date_creation}</Text>
                        </View>
                        <View style={[styles.cellRow, { flex: 2 }]}>
                          <Text style={styles.textRow}>{f.no_piece}</Text>
                        </View>
                        <View style={[styles.cellRow, { flex: 2 }]}>
                          <Text style={styles.textRow}>
                            {f.compte_fournisseur}
                          </Text>

                          {f.accounts &&
                              f.accounts[0].map((account) => {
                                return (
                                    <Text style={styles.textRow}>{account}</Text>
                                );
                              })}

                        </View>
                        <View style={[styles.cellRow, { flex: 3 }]}>
                          <Text style={styles.textRow}>{"-"}</Text>
                        </View>
                        <View style={[styles.cellRow, { flex: 3 }]}>
                          <Text style={styles.textRow}>
                            {f.libelle_fournisseur}
                          </Text>
                        </View>
                        <View
                            style={[
                              styles.cellRow,
                              { flex: 3, borderLeftWidth: 1 },
                            ]}
                        >

                          {f.debit &&
                              f.debit[0].map((d) => {
                                return (
                                    <Text
                                        style={[styles.textRow, { textAlign: "right" }]}
                                    >
                                      {Number(d).toFixed(2)}
                                    </Text>
                                );
                              })}
                        </View>
                        <View
                            style={[
                              styles.cellRow,
                              { flex: 3, borderLeftWidth: 1 },
                            ]}
                        >

                          {f.credit &&
                              f.credit[0].map((c) => {
                                return (
                                    <Text
                                        style={[styles.textRow, {textAlign: "right"}]}
                                    >
                                      {Number(c).toFixed(2)}
                                    </Text>
                                );
                              })}
                        </View>
                      </View>
                  );

                } else {

                  if(f.invoice_type === "piece"){
                    total_credit += parseFloat(f.credit);
                    total_debit += parseFloat(f.debit);
                  }else{
                    total_credit += parseFloat(f.total_ttc);
                    total_debit += parseFloat(f.total_ttc);
                  }

                  return (
                      <View style={styles.row}>
                        <View style={[styles.cellRow, {flex: 2}]}>
                          <Text style={styles.textRow}>{f.date_creation}</Text>
                        </View>
                        <View style={[styles.cellRow, {flex: 2}]}>
                          <Text style={styles.textRow}>{f.no_piece}</Text>
                        </View>
                        <View style={[styles.cellRow, {flex: 2}]}>
                          <Text style={styles.textRow}>{f.compte_fournisseur}</Text>
                          <Text style={styles.textRow}>{f.payment_account}</Text>
                          <Text style={styles.textRow}>
                            {f.banquePaymentOption === null
                                ? ""
                                : f.banquePaymentOption +
                                (f.banquePaymentOption !== "chéque" ? "" : " - " + f.chequeId)}
                          </Text>
                          <Text style={styles.textRow}>{"\n"}</Text>
                        </View>
                        <View style={[styles.cellRow, {flex: 3}]}>
                          <Text style={styles.textRow}>{f.sous_compte}</Text>
                        </View>
                        <View style={[styles.cellRow, {flex: 3}]}>
                          <Text style={styles.textRow}>
                            {f.banquePaymentOption === null
                                ? f.libelle_fournisseur
                                : f.banquePaymentOption +
                                (f.banquePaymentOption !== "chéque" ? "" : " - " + f.chequeId)}
                          </Text>
                        </View>

                        <View
                            style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}
                        >
                          {f.invoice_type === "vente" ? (
                              <Text style={[styles.textRow, {textAlign: "right"}]}>
                                <Text style={styles.textRow}>{"\n"}</Text>
                                {Number(f.total_ttc).toFixed(2)}
                              </Text>
                          ) : f.invoice_type === "piece" ? (
                              <Text style={[styles.textRow, {textAlign: "right"}]}>
                                <Text style={styles.textRow}>{"\n"}</Text>
                                {Number(f.debit).toFixed(2)}
                              </Text>
                          ) : (
                              <Text style={[styles.textRow, {textAlign: "right"}]}>
                                {Number(f.total_ttc).toFixed(2)}
                              </Text>
                          )}
                        </View>

                        <View
                            style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}
                        >
                          {f.invoice_type === "vente" ? (
                              <Text style={[styles.textRow, {textAlign: "right"}]}>
                                {Number(f.total_ttc).toFixed(2)}
                              </Text>
                          ) : f.invoice_type === "piece" ? (
                              <Text style={[styles.textRow, {textAlign: "right"}]}>
                                {Number(f.credit).toFixed(2)}
                              </Text>
                          ) : (
                              <Text style={[styles.textRow, {textAlign: "right"}]}>
                                <Text style={styles.textRow}>{"\n"}</Text>
                                {Number(f.total_ttc).toFixed(2)}
                              </Text>
                          )}
                        </View>
                      </View>

                  )
                }
              })}

              {/*TOTAL*/}
              {["ACH", "VTE", "RAN", "OD"].includes(subCodeFC) ? (
                <View style={[styles.row, { borderTopWidth: 1 }]}>
                  <View style={[styles.cellRow, { flex: 2 }]}>
                    <Text style={styles.textRow}></Text>
                  </View>
                  <View style={[styles.cellRow, { flex: 2 }]}>
                    <Text style={styles.textRow}></Text>
                  </View>
                  <View style={[styles.cellRow, { flex: 2 }]}>
                    <Text style={styles.textRow}></Text>
                    <Text style={styles.textRow}></Text>
                  </View>
                  <View style={[styles.cellRow, { flex: 3 }]}>
                    <Text style={styles.textRow}></Text>
                  </View>
                  <View style={[styles.cellRow, { flex: 3 }]}>
                    <Text
                      style={[
                        styles.textRow,
                        { textAlign: "right", fontWeight: "bold" },
                      ]}
                    >
                      Totaux
                    </Text>
                  </View>
                  <View
                    style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}
                  >
                    <Text
                      style={[
                        styles.textRow,
                        { textAlign: "right", fontWeight: "bold" },
                      ]}
                    >
  {subCodeFC === "ACH"
  ? isNaN(Number(total_debit).toFixed(2)) 
    ? Number(total_credit).toFixed(2) 
    : Number(total_debit).toFixed(2)
  : subCodeFC === "VTE"
  ? Number(total_credit).toFixed(2)
  : isNaN(Number(total_debit).toFixed(2)) 
  ? Number(total_credit).toFixed(2) 
  : Number(total_debit).toFixed(2)}

                    </Text>
                  </View>
                  <View
                    style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}
                  >
                    <Text
                      style={[
                        styles.textRow,
                        { textAlign: "right", fontWeight: "bold" },
                      ]}
                    >
                      {subCodeFC === "ACH"
                        ? Number(total_credit).toFixed(2)
                        : subCodeFC === "VTE"
                        ? Number(total_credit).toFixed(2)
                        : isNaN(Number(total_debit).toFixed(2)) 
                        ? Number(total_credit).toFixed(2) 
                        : Number(total_debit).toFixed(2)}
                    </Text>
                  </View>
                </View>
              ) : null}

              {["BQ", "CS"].includes(subCodeFC) ? (
                <View style={[styles.row, { borderTopWidth: 1 }]}>
                  <View style={[styles.cellRow, { flex: 2 }]}>
                    <Text style={styles.textRow}></Text>
                  </View>
                  <View style={[styles.cellRow, { flex: 2 }]}>
                    <Text style={styles.textRow}></Text>
                  </View>
                  <View style={[styles.cellRow, { flex: 2 }]}>
                    <Text style={styles.textRow}></Text>
                    <Text style={styles.textRow}></Text>
                  </View>
                  <View style={[styles.cellRow, { flex: 3 }]}>
                    <Text style={styles.textRow}></Text>
                  </View>
                  <View style={[styles.cellRow, { flex: 3 }]}>
                    <Text
                      style={[
                        styles.textRow,
                        { textAlign: "right", fontWeight: "bold" },
                      ]}
                    >
                      Totaux
                    </Text>
                  </View>
                  <View
                    style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}
                  >
                    <Text
                      style={[
                        styles.textRow,
                        { textAlign: "right", fontWeight: "bold" },
                      ]}
                    >
                      {Number(total_debit).toFixed(2)}
                    </Text>
                  </View>
                  <View
                    style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}
                  >
                    <Text
                      style={[
                        styles.textRow,
                        { textAlign: "right", fontWeight: "bold" },
                      ]}
                    >
                      {Number(total_credit).toFixed(2)}
                    </Text>
                  </View>
                </View>
              ) : null}

            </View>
          </View>
        </Page>
      </Document>
    );
  };

  /**
   * exportation pdf du journal dans la grille :) on click Exporter tous
   *
   * @param data pour FV
   * @param data2
   * @param codeFacture Ventes,
   * @param subCodeFC VTE,
   * @param is_custom_month
   * @param custom_month
   * @return {JSX.Element}
   * @constructor
   */
  const JournalPage = ({
    data = [],
    data2 = [],
    codeFacture = "",
    subCodeFC = "",
    is_custom_month = false,
    custom_month = "",
  }) => {
    let total_debit = 0;
    let total_credit = 0;
    let month = null;
    let indexMonth = months.findIndex((m) => m.code === chooseMonth);
    if (indexMonth > -1) {
      month = months[indexMonth];
    }
    let date_now = new Date();
    let copyIcon = " © ";
    const onLayout = (event) => {
      const { x, y, height, width } = event.nativeEvent.layout;
      console.log("view height", height);
    };
    return (
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          {/*HEADER*/}
          <View style={styles.headerPage}>
            <View style={styles.leftSide}>
              <Text>{organisation?.name}</Text>
              <Text>Impression provisoire</Text>
            </View>
            <View style={styles.centerContainer}>
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 18,
                  fontWeight: "bold",
                  marginBottom: 6,
                }}
              >
                Journal
              </Text>
              <View style={{ flexDirection: "row" }}>
                <Text style={{ marginRight: 30, fontSize: 11.5 }}>
                  {subCodeFC}
                </Text>
                <Text style={{ fontSize: 11.5 }}>{codeFacture}</Text>
              </View>
            </View>
            <View style={styles.rightSide}>
              <View
                style={{ flexDirection: "row", justifyContent: "flex-end" }}
              >
                <Text style={{ textAlign: "right", marginRight: 4 }}>
                  Tenue de compte :{" "}
                </Text>
                <Text style={{ textAlign: "right" }}>
                  {is_custom_month ? custom_month : month?.name_fr}{" "}
                  {/*{date_now?.getFullYear()}*/}
                </Text>
              </View>
            </View>
          </View>

          <View style={[styles.headerPage, { border: 0, padding: 0 }]}>
            <View style={styles.leftSide}>
              <Text style={{ fontSize: 9 }}>
                {copyIcon}
                <Text style={{ htmlContnet: "\\00A9" }}></Text>
                {"ELMANAGER COMMERCIALISATION ET COMPTABILITE"}
              </Text>
            </View>
            <View style={[{ justifyContent: "flex-end" }]}>
              <View style={{ flexDirection: "row", alignItems: "flex-end" }}>
                <Text style={{ textAlign: "right", marginRight: 4 }}>
                  Date de tirage :{" "}
                </Text>
                <Text style={{ textAlign: "right" }}>
                  {date_now?.getDate()}/{date_now?.getMonth() + 1}/
                  {date_now?.getFullYear()} à {date_now?.getUTCHours() + 1}:
                  {date_now?.getMinutes() < 10
                    ? "0" + date_now?.getMinutes()
                    : date_now?.getMinutes()}
                </Text>
              </View>
            </View>
          </View>
          {/*TABLE ROW TR*/}
          <View style={styles.header}>
            <View style={[styles.cell, { flex: 2 }]}>
              <Text style={styles.textHeader}>Jour</Text>
            </View>
            <View style={[styles.cell, { flex: 2 }]}>
              <Text style={styles.textHeader}>N° pièce</Text>
            </View>
            <View style={[styles.cell, { flex: 2 }]}>
              <Text style={styles.textHeader}>N° compte</Text>
            </View>
            <View style={[styles.cell, { flex: 3 }]}>
              <Text style={styles.textHeader}>N° tiers</Text>
            </View>
            <View style={[styles.cell, { flex: 3 }]}>
              <Text style={styles.textHeader}>Libellé écriture</Text>
            </View>
            <View style={[styles.cell, { flex: 3 }]}>
              <Text style={styles.textHeader}>Mvts débit</Text>
            </View>
            <View style={[styles.cell, { flex: 3, borderRightWidth: 0 }]}>
              <Text>Mvts crédit</Text>
            </View>
          </View>

          <View ref={refPagePdf} onLayout={onLayout} style={{ border: 1 }}>
            {data.map((flux) => {
              if (flux.from === "invoice_module") {
                total_credit += parseFloat(flux.total_ttc);
                console.log(flux?.total_ht_et_tva);
                return (
                  <View style={styles.row}>
                    <View style={[styles.cellRow, { flex: 2 }]}>
                      <Text style={styles.textRow}>{flux.date_creation}</Text>
                    </View>
                    <View style={[styles.cellRow, { flex: 2 }]}>
                      <Text style={styles.textRow}>{flux.no_piece}</Text>
                    </View>
                    <View style={[styles.cellRow, { flex: 2 }]}>
                      <Text style={styles.textRow}>
                        {flux.compte_fournisseur}
                      </Text>
                      {flux.compte_tva?.map((tva) => {
                        return <Text style={styles.textRow}>{tva}</Text>;
                      })}
                      {flux?.compte_compte_de_charge?.map(
                        (compte_de_charge) => {
                          return (
                            <Text style={styles.textRow}>
                              {compte_de_charge}
                            </Text>
                          );
                        }
                      )}
                    </View>
                    <View style={[styles.cellRow, { flex: 3 }]}>
                      <Text style={styles.textRow}>{flux.sous_compte}</Text>
                    </View>
                    <View style={[styles.cellRow, { flex: 3 }]}>
                      <Text style={styles.textRow}>
                        {flux.libelle_fournisseur}
                      </Text>
                    </View>
                    <View
                      style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}
                    >
                      {flux.invoice_type === "vente" ? (
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {Number(flux.total_ttc).toFixed(2)}
                        </Text>
                      ) : (
                        flux?.total_ht_et_tva?.map(
                          (total_ht_et_tva, elt = 0) => {
                            total_debit +=
                              total_ht_et_tva != "<br />" ? total_ht_et_tva : 0;
                            console.log(total_ht_et_tva);
                            if (elt === 0) {
                              elt++;
                              return (
                                <Text
                                  style={[
                                    styles.textRow,
                                    { textAlign: "right" },
                                  ]}
                                >
                                  {"\n"}
                                </Text>
                              );
                            }
                            return (
                              <Text
                                style={[styles.textRow, { textAlign: "right" }]}
                              >
                                {Number(total_ht_et_tva).toFixed(2)}
                              </Text>
                            );
                          }
                        )
                      )}
                    </View>
                    <View
                      style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}
                    >
                      {flux.invoice_type === "vente" ? (
                        flux?.total_ht_et_tva?.map(
                          (total_ht_et_tva, elt = 0) => {
                            total_debit +=
                              total_ht_et_tva != "<br />" ? total_ht_et_tva : 0;
                            if (elt === 0) {
                              elt++;
                              return (
                                <Text
                                  style={[
                                    styles.textRow,
                                    { textAlign: "right" },
                                  ]}
                                >
                                  {"\n"}
                                </Text>
                              );
                            }
                            return (
                              <Text
                                style={[styles.textRow, { textAlign: "right" }]}
                              >
                                {Number(total_ht_et_tva).toFixed(2)}
                              </Text>
                            );
                          }
                        )
                      ) : (
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {Number(flux.total_ttc).toFixed(2)}
                        </Text>
                      )}
                    </View>
                  </View>
                );
              } else {
                flux.debit &&
                  flux.debit[0].map((c) => {
                    total_debit += parseFloat(c);
                  });
                flux.credit &&
                  flux.credit[0].map((c) => {
                    total_credit += parseFloat(c);
                  });
                return (
                  <View style={styles.row}>
                    <View style={[styles.cellRow, { flex: 2 }]}>
                      <Text style={styles.textRow}>{flux.date_creation}</Text>
                    </View>
                    <View style={[styles.cellRow, { flex: 2 }]}>
                      <Text style={styles.textRow}>{flux.no_piece}</Text>
                    </View>
                    <View style={[styles.cellRow, { flex: 2 }]}>
                      <Text style={styles.textRow}>
                        {flux.compte_fournisseur}
                      </Text>

                      {flux.accounts &&
                        flux.accounts[0].map((account) => {
                          return <Text style={styles.textRow}>{account}</Text>;
                        })}

                      {flux?.nature === 'is_bq_cs' ?
                          <Text style={styles.textRow}>{flux?.sous_compte}</Text>
                          : null
                      }
                    </View>
                    <View style={[styles.cellRow, { flex: 3 }]}>
                      <Text style={styles.textRow}>{"-"}</Text>
                    </View>
                    <View style={[styles.cellRow, { flex: 3 }]}>
                      <Text style={styles.textRow}>
                        {flux.libelle_fournisseur}
                      </Text>
                    </View>
                    <View
                      style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}
                    >
                      {flux.from === "ocr_ec_module" ? (
                        <Text style={styles.textRow}>{"\n"}</Text>
                      ) : null}
                      {flux.debit &&
                        flux.debit[0].map((d) => {
                          return (
                            <Text
                              style={[styles.textRow, { textAlign: "right" }]}
                            >
                              {Number(d).toFixed(2)}
                            </Text>
                          );
                        })}
                    </View>
                    <View
                      style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}
                    >
                      {flux.from === "ocr_ec_module" ? (
                        <Text style={styles.textRow}>{"\n"}</Text>
                      ) : null}
                      {flux.credit &&
                        flux.credit[0].map((c) => {
                          return (
                            <Text
                              style={[styles.textRow, { textAlign: "right" }]}
                            >
                              {Number(c).toFixed(2)}
                            </Text>
                          );
                        })}
                    </View>
                  </View>
                );
              }
            })}
            {data2.map((f) => {

              if(f.isSousCompteBqCs){

                f.debit &&
                f.debit[0].map((c) => {
                  total_debit += parseFloat(c);
                });
                f.credit &&
                f.credit[0].map((c) => {
                  total_credit += parseFloat(c);
                });

                return (
                    <View style={styles.row}>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>{f.date_creation}</Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>{f.no_piece}</Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>
                          {f.compte_fournisseur}
                        </Text>

                        {f.accounts &&
                            f.accounts[0].map((account) => {
                              return (
                                  <Text style={styles.textRow}>{account}</Text>
                              );
                            })}

                      </View>
                      <View style={[styles.cellRow, { flex: 3 }]}>
                        <Text style={styles.textRow}>{"-"}</Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 3 }]}>
                        <Text style={styles.textRow}>
                          {f.libelle_fournisseur}
                        </Text>
                      </View>
                      <View
                          style={[
                            styles.cellRow,
                            { flex: 3, borderLeftWidth: 1 },
                          ]}
                      >

                        {f.debit &&
                            f.debit[0].map((d) => {
                              return (
                                  <Text
                                      style={[styles.textRow, { textAlign: "right" }]}
                                  >
                                    {Number(d).toFixed(2)}
                                  </Text>
                              );
                            })}
                      </View>
                      <View
                          style={[
                            styles.cellRow,
                            { flex: 3, borderLeftWidth: 1 },
                          ]}
                      >

                        {f.credit &&
                            f.credit[0].map((c) => {
                              return (
                                  <Text
                                      style={[styles.textRow, {textAlign: "right"}]}
                                  >
                                    {Number(c).toFixed(2)}
                                  </Text>
                              );
                            })}
                      </View>
                    </View>
                );

              }else{

                if(f.invoice_type === "piece"){
                  total_credit += parseFloat(f.credit);
                  total_debit += parseFloat(f.debit);
                }else{
                  total_credit += parseFloat(f.total_ttc);
                  total_debit += parseFloat(f.total_ttc);
                }

              //total_credit += parseFloat(f.total_ttc);
              console.log(f?.total_ht_et_tva);
              return (
                <View key={Math.random()} style={styles.row}>
                  <View style={[styles.cellRow, { flex: 2 }]}>
                    <Text style={styles.textRow}>{f.date_creation}</Text>
                  </View>
                  <View style={[styles.cellRow, { flex: 2 }]}>
                    <Text style={styles.textRow}>{f.no_piece}</Text>
                  </View>
                  <View style={[styles.cellRow, { flex: 2 }]}>
                    <Text style={styles.textRow}>{f.compte_fournisseur}</Text>
                    <Text style={styles.textRow}>{f.payment_account}</Text>
                    <Text style={styles.textRow}>
                      {f.banquePaymentOption === null
                        ? ""
                        : f.banquePaymentOption +
                          (f.banquePaymentOption !== "chéque" ? "" : " - " + f.chequeId)}
                    </Text>
                    <Text style={styles.textRow}>{"\n"}</Text>
                  </View>
                  <View style={[styles.cellRow, { flex: 3 }]}>
                    <Text style={styles.textRow}>{f.sous_compte}</Text>
                  </View>
                  <View style={[styles.cellRow, { flex: 3 }]}>
                    <Text style={styles.textRow}>
                      {f.banquePaymentOption === null
                        ? f.libelle_fournisseur
                        : f.banquePaymentOption +
                          (f.banquePaymentOption !== "chéque" ? "" : " - " + f.chequeId)}
                    </Text>
                  </View>
                  <View
                    style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}
                  >
                    {f.invoice_type === "vente" ? (
                      <Text style={[styles.textRow, { textAlign: "right" }]}>
                        <Text style={styles.textRow}>{"\n"}</Text>
                        {Number(f.total_ttc).toFixed(2)}
                      </Text>
                    ) : f.invoice_type === "piece" ?
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          <Text style={styles.textRow}>{"\n"}</Text>
                          {Number(f.debit).toFixed(2)}
                        </Text>
                        :  (
                      <Text style={[styles.textRow, { textAlign: "right" }]}>
                        {Number(f.total_ttc).toFixed(2)}
                      </Text>
                    )}
                  </View>
                  <View
                    style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}
                  >
                    {f.invoice_type === "vente" ? (
                      <Text style={[styles.textRow, { textAlign: "right" }]}>
                        {Number(f.total_ttc).toFixed(2)}
                      </Text>
                    ) : f.invoice_type === "piece" ?
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          <Text style={styles.textRow}>{"\n"}</Text>
                          {Number(f.credit).toFixed(2)}
                        </Text>
                        : (
                      <Text style={[styles.textRow, { textAlign: "right" }]}>
                        <Text style={styles.textRow}>{"\n"}</Text>
                        {Number(f.total_ttc).toFixed(2)}
                      </Text>
                    )}
                  </View>
                </View>
              )

              }
            })}
            {["ACH", "VTE", "RAN", "OD"].includes(subCodeFC) ? (
              <View style={[styles.row, { borderTopWidth: 1 }]}>
                <View style={[styles.cellRow, { flex: 2 }]}>
                  <Text style={styles.textRow}></Text>
                </View>
                <View style={[styles.cellRow, { flex: 2 }]}>
                  <Text style={styles.textRow}></Text>
                </View>
                <View style={[styles.cellRow, { flex: 2 }]}>
                  <Text style={styles.textRow}></Text>
                  <Text style={styles.textRow}></Text>
                </View>
                <View style={[styles.cellRow, { flex: 3 }]}>
                  <Text style={styles.textRow}></Text>
                </View>
                <View style={[styles.cellRow, { flex: 3 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    Totaux
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
  {subCodeFC === "ACH"
  ? isNaN(Number(total_debit).toFixed(2)) 
    ? Number(total_credit).toFixed(2) 
    : Number(total_debit).toFixed(2)
  : subCodeFC === "VTE"
  ? Number(total_credit).toFixed(2)
  : isNaN(Number(total_debit).toFixed(2)) 
  ? Number(total_credit).toFixed(2) 
  : Number(total_debit).toFixed(2)}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                      {subCodeFC === "ACH"
                        ? Number(total_credit).toFixed(2)
                        : subCodeFC === "VTE"
                        ? Number(total_credit).toFixed(2)
                        : isNaN(Number(total_debit).toFixed(2)) 
  ? Number(total_credit).toFixed(2) 
  : Number(total_debit).toFixed(2)}
                  </Text>
                </View>
              </View>
            ) : null}
            {["BQ", "CS"].includes(subCodeFC) ? (
              <View style={[styles.row, { borderTopWidth: 1 }]}>
                <View style={[styles.cellRow, { flex: 2 }]}>
                  <Text style={styles.textRow}></Text>
                </View>
                <View style={[styles.cellRow, { flex: 2 }]}>
                  <Text style={styles.textRow}></Text>
                </View>
                <View style={[styles.cellRow, { flex: 2 }]}>
                  <Text style={styles.textRow}></Text>
                  <Text style={styles.textRow}></Text>
                </View>
                <View style={[styles.cellRow, { flex: 3 }]}>
                  <Text style={styles.textRow}></Text>
                </View>
                <View style={[styles.cellRow, { flex: 3 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    Totaux
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(total_debit).toFixed(2)}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(total_credit).toFixed(2)}
                  </Text>
                </View>
              </View>
            ) : null}
          </View>
        </View>
      </Page>
    );
  };

  const [jfa, setJFA] = useState([]);
  const [jfv, setJFV] = useState([]);
  const [jbq, setJBQ] = useState([]);
  const [jcs, setJCS] = useState([]);
  const [jran, setJRAN] = useState([]);
  const [jod, setJOD] = useState([]);
  const [allDone, setAllDone] = useState([]);
  const [loadingFA, setLoadingFA] = useState(null);
  const [loadingFV, setLoadingFV] = useState(null);
  const [loadingBQ, setLoadingBQ] = useState(null);
  const [loadingCS, setLoadingCS] = useState(null);
  const [loadingRAN, setLoadingRAN] = useState(null);
  const [loadingOD, setLoadingOD] = useState(null);

  const preparAllJournals = () => {
    setJFV([]);
    setJFA([]);
    setJBQ([]);
    setJCS([]);
    setJRAN([]);
    setJOD([]);

    //get FA
    let invsFA = invoices.filter(
      (invoice) =>
        moment(invoice.created_at).format("MM") === chooseMonth.toString() &&
          moment(invoice.created_at).format("YYYY") === currentYear.toString() &&
        getCodeCores("FA").includes(invoice.type)
    );
    if (invsFA.length === 0) {
      setLoadingFA(true);
    } else {
      invsFA.map((invoice) => {
        if (
          moment(invoice.created_at).format("MM") === chooseMonth.toString() &&
            moment(invoice.created_at).format("YYYY") === currentYear.toString() &&
          getCodeCores("FA").includes(invoice.type)
        ) {
          setLoadingFA(false);
          let fl = getEcEcoV2(invoice);
          if (fl != null) {
            setJFA((d2) => [...d2, fl]);
          }
          setLoadingFA(true);

          let flux = getPieceLierV2(invoice);
          if (flux != null) {
            setJFA((d2) => [...d2, flux]);
          }
          setLoadingFA(true);
        }
      });
    }

    //get FV
    let invsFV = invoices.filter(
      (invoice) =>
        moment(invoice.created_at).format("MM") === chooseMonth.toString() &&
          moment(invoice.created_at).format("YYYY") === currentYear.toString() &&
        getCodeCores("FV").includes(invoice.type)
    );
    if (invsFV.length === 0) {
      setLoadingFV(true);
    } else {
      invsFV.map((invoice) => {
        if (
          moment(invoice.created_at).format("MM") === chooseMonth.toString() &&
            moment(invoice.created_at).format("YYYY") === currentYear.toString() &&
          getCodeCores("FV").includes(invoice.type)
        ) {
          setLoadingFV(false);
          let fl = getEcEcoV2(invoice);
          if (fl != null) {
            setJFV((d2) => [...d2, fl]);
          }
          setLoadingFV(true);

          let flux = getPieceLierV2(invoice);
          if (flux != null) {
            setJFV((d2) => [...d2, flux]);
          }
          setLoadingFV(true);
        }
      });
    }

    //get BQ
    invoices.filter((invoice) => {
      let payedAmounts = 0;
      let letTotalhtFluxFin = 0;
      let le_compte_fournisseur = "";
      let invoice_type = "";
      let total_ttc = 0;

      for (let i = 0; i < invoice.payment.length; i++) {
        if ([2, 3].includes(invoice.payment[i].status.id)) {
          console.log("invoice selected : ", invoice);
          payedAmounts += parseFloat(invoice.payment[i].payed_amount);

          console.log("enter");
          setLoadingBQ(false);
          console.log("allBqAccounts: ", allBqAccounts);
          console.log(
            "invoice.payment[i].payment_account.code.includes(allBqAccounts): ",
            invoice.payment[i].payment_account.code.includes(allBqAccounts)
          );

          //if (moment(invoice.payment[i].created_at).format("MM") === chooseMonth.toString() && invoice.payment[i].payment_account.code === getCodeCores("BQ")
          if (
            moment(invoice.payment[i].created_at).format("MM") ===
              chooseMonth.toString() &&
              moment(invoice.payment[i].created_at).format("YYYY") ===
              currentYear.toString() &&
            isBqSousCompte(invoice.payment[i].payment_account.code)
          ) {
            if (i === 0 && invoice.payment[i].status.id === 2) {
              letTotalhtFluxFin = invoice.total_ttc;
            } else if (i > 0 && invoice.payment[i].status.id === 2) {
              //condition 2, is paid from the x iteration
              letTotalhtFluxFin = parseFloat(invoice.total_ttc) - payedAmounts;
            } else {
              //condition 3, if not paid yet
              letTotalhtFluxFin = invoice.payment[i].payed_amount;
            }

            if (invoice.type === "achat") {
              total_ttc = invoice.total_ttc;
              invoice_type = "achat";
              le_compte_fournisseur = "4411000";
            } else if (invoice.type === "vente") {
              total_ttc = invoice.total_ttc;
              invoice_type = "vente";
              le_compte_fournisseur = "34210000";
            } else if (invoice.type === "depense") {
              total_ttc = invoice.total_ttc;
              invoice_type = "depense";
              le_compte_fournisseur = "4411000";
            }

            let elt = {
              date_creation: moment(invoice.payment[i].created_at).format(
                "DD/MM/YYYY"
              ),
              no_piece: invoice.type.charAt(0) + "" + invoice.id,
              compte_fournisseur: le_compte_fournisseur,
              sous_compte: invoice.client.account.code,
              payment_account: invoice.payment[i].payment_account.code,
              banquePaymentOption: invoice.payment[i].banquePaymentOption,
              chequeId: invoice.payment[i].chequeId,
              libelle_fournisseur: invoice.client.companyName,
              invoice_type: invoice_type,
              total_ttc: Number(letTotalhtFluxFin).toFixed(2),
            };
            setJBQ((d4) => [...d4, elt]);
            //setLoadingBQ(true);
          } else {
            //setLoadingBQ(true);
          }
        }
      }
    });
    setLoadingBQ(true);

    //get it from piece's transaction
    pieces.map((piece) => {
      if (isBqSousCompte(piece['debit_credit'][0]["account"]["code"])) {
        if (
            moment(piece.created_at).format("MM") === chooseMonth.toString() && moment(piece.created_at).format("YYYY") === currentYear.toString()
        ) {
          let flux = getPieceEc(piece, true);
          if (flux != null) {
            setJBQ((d4) => [...d4, flux]);
          }
        }
      }
    });

    //get CS
    invoices.filter((invoice) => {
      let payedAmounts = 0;
      let letTotalhtFluxFin = 0;
      let le_compte_fournisseur = "";
      let invoice_type = "";
      let total_ttc = 0;

      for (let i = 0; i < invoice.payment.length; i++) {
        if ([2, 3].includes(invoice.payment[i].status.id)) {
          console.log("invoice selected : ", invoice);
          payedAmounts += parseFloat(invoice.payment[i].payed_amount);

          console.log("enter");
          setLoadingCS(false);

          if (
            moment(invoice.payment[i].created_at).format("MM") ===
              chooseMonth.toString() &&
              moment(invoice.payment[i].created_at).format("YYYY") ===
              currentYear.toString() &&
              isCsSousCompte(invoice.payment[i].payment_account.code)
          ) {
            if (i === 0 && invoice.payment[i].status.id === 2) {
              letTotalhtFluxFin = invoice.total_ttc;
            } else if (i > 0 && invoice.payment[i].status.id === 2) {
              //condition 2, is paid from the x iteration
              letTotalhtFluxFin = parseFloat(invoice.total_ttc) - payedAmounts;
            } else {
              //condition 3, if not paid yet
              letTotalhtFluxFin = invoice.payment[i].payed_amount;
            }

            if (invoice.type === "achat") {
              total_ttc = invoice.total_ttc;
              invoice_type = "achat";
              le_compte_fournisseur = "4411000";
            } else if (invoice.type === "vente") {
              total_ttc = invoice.total_ttc;
              invoice_type = "vente";
              le_compte_fournisseur = "34210000";
            } else if (invoice.type === "depense") {
              total_ttc = invoice.total_ttc;
              invoice_type = "depense";
              le_compte_fournisseur = "4411000";
            }

            let elt = {
              date_creation: moment(invoice.payment[i].created_at).format(
                "DD/MM/YYYY"
              ),
              no_piece: invoice.type.charAt(0) + "" + invoice.id,
              compte_fournisseur: le_compte_fournisseur,
              sous_compte: invoice.client.account.code,
              payment_account: invoice.payment[i].payment_account.code,
              banquePaymentOption: invoice.payment[i].banquePaymentOption,
              chequeId: invoice.payment[i].chequeId,
              libelle_fournisseur: invoice.client.companyName,
              invoice_type: invoice_type,
              total_ttc: Number(letTotalhtFluxFin).toFixed(2),
            };
            setJCS((d4) => [...d4, elt]);
            //setLoadingCS(true);
          } else {
            //setLoadingCS(true);
          }
        }
      }

    });

    //get it from piece's transaction
    pieces.map((piece) => {
      if (isCsSousCompte(piece['debit_credit'][0]["account"]["code"])) {
        if (
            moment(piece.created_at).format("MM") === chooseMonth.toString() && moment(piece.created_at).format("YYYY") === currentYear.toString()
        ) {
          let flux = getPieceEc(piece, true);
          if (flux != null) {
            setJCS((d4) => [...d4, flux]);
          }
        }
      }
    });

    setLoadingCS(true);

    //get RAN
    let invsRAN = pieces.filter(
      (piece) =>
        moment(piece.created_at).format("MM") === chooseMonth.toString() &&
          moment(piece.created_at).format("YYYY") === currentYear.toString() &&
        piece.journal === getCodeCores("RAN")
    );
    console.log("prepar ran", invsRAN);
    if (invsRAN.length === 0) {
      setLoadingRAN(true);
    } else {
      invsRAN.map((piece) => {
        setLoadingRAN(false);
        let flux = getPieceEc(piece);
        if (flux != null) {
          setJRAN((d6) => [...d6, flux]);
        }
        setLoadingRAN(true);
      });
    }

    let invsOD = pieces.filter(
      (piece) =>
        moment(piece.created_at).format("MM") === chooseMonth.toString() &&
          moment(piece.created_at).format("YYYY") === currentYear.toString() &&
        piece.journal === getCodeCores("OD")
    );
    if (invsOD.length === 0) {
      setLoadingOD(true);
    } else {
      invsOD.map((piece) => {
        setLoadingOD(false);
        let flux = getPieceEc(piece);
        if (flux != null) {
          setJOD((d6) => [...d6, flux]);
        }
        setLoadingOD(true);
      });
    }

    setEcsLoaded(0);
  };

  const ExportAllJournals = ({
    fa = [],
    fv = [],
    bq = [],
    cs = [],
    ran = [],
    od = [],
  }) => {
    console.log("bq: ",bq);
    return (
      <Document>
        <JournalPage data={fa} codeFacture="Achats" subCodeFC="ACH" />
        <JournalPage data={fv} codeFacture="Ventes" subCodeFC="VTE" />
        <JournalPage data2={bq} codeFacture="BANQUE" subCodeFC="BQ" />
        <JournalPage data2={cs} codeFacture="CAISSE" subCodeFC="CS" />
        <JournalPage
          data={ran}
          codeFacture="Raport à nouveau"
          subCodeFC="RAN"
        />
        <JournalPage
          data={od}
          codeFacture="Opération diverses"
          subCodeFC="OD"
        />
      </Document>
    );
  };

  /**
   * exportation csv du jr dans la grille
   */
  const exportCsvEc = () => {
    let mois = " du " + chooseMonth + "/" + new Date().getFullYear();

    if (["FA", "FV"].includes(filterOption)) {
      let header =
        "journal comptable " + (filterOption === "FA" ? "des achats" : "des ventes");
      exportJr(invoicesEcs, filterOption, header + mois);
    } else if (["BQ", "CS", "ALLBQ","ALLCS"].includes(filterOption)) {
      console.log("user filter option is: ",filterOption);
      let header =
        "journal comptable " +
        (filterOption === "BQ" || filterOption === "ALLBQ"  ? "de la banque" : "de la caisse");
      exportJr(invoicesEcsFf, filterOption, header + mois);
    } else if (["RAN", "OD"].includes(filterOption)) {
      let header =
        "journal comptable " +
        (filterOption === "RAN"
          ? "du Report à nouveau"
          : "des opération diverses");
      exportJr(invoicesEcs, filterOption, header + mois);
    } else if (filterOption === "all") {
      console.log([...jfa],[...jfv],[...jbq],[...jcs],[...jran],[...jod]);

      let header = "journal comptable ";
      exportJr(invoicesEcs, filterOption, header + mois, true, [
        [...jfa],
        [...jfv],
        [...jbq],
        [...jcs],
        [...jran],
        [...jod],
      ]);
      //exportJr(invoicesEcs, filterOption,header+mois);
    } else if (isBqSousCompte(filterOption)) {
      let header =
        "journal comptable " +
        (isBqSousCompte(filterOption)
          ? "de la banque " + filterOption.toString()
          : "de la caisse");
      exportJr(invoicesEcsFf, filterOption, header + mois);
    }else if (isCsSousCompte(filterOption)) {
      let header =
          "journal comptable " +"de la Caisse " + filterOption.toString();
      exportJr(invoicesEcsFf, filterOption, header + mois);
    }
  };

  const modalDateExportAllMonths = async () => {
    //setSelectedMonths(selectedMonths.sort());
    //console.log(selectedMonths);
    clearSelection();
    setSousCompte("");
    setGetBqSousCompte(false);
    setGetCsSousCompte(false);
    window.$("#modalDateExportAllInvoices").modal("show");
  };

  const exportData = (data, type, header,monthRange,typeJournal=null) => {
    if (data && data.length > 0) {
      exportJr(data, type, `${header}${monthRange}`);
    }else{
      /**
       *
       * @type {string}
       */
      let messageWarning="";

      if(typeJournal!==null){
        messageWarning="Journal vide pour la date fournie et le type est: "+typeJournal
      }else{
        messageWarning="Journal vide pour la date et type fournie !";
      }

      toast.warning(t(messageWarning), {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const exportAllInvoicesByDate = async () => {
    //initialize states
    setMsgErrorDate("");
    setSelectedMonths([]);
    setInvsDataFiltered(null);
    setSelectedExportType(null);
    /**
     * selected months array, ex: if from is 01 and to 04
     * array will be: [1,2,3,4]
     * @type {*[]}
     */
    const monthsSelected = [];

    //get popup form input values
    const fromDate = document.getElementById("date-from");
    const toDate = document.getElementById("date-to");
    const typeInv = document.getElementById("type-facture");

    if (fromDate && toDate && typeInv) {
      /**
       * check if from and to date are not null
       * @type Boolean
       */
      let allRequiredInputsAreValid = fromDate.value && toDate.value;
      
      if (typeInv.value === "BQ" || typeInv.value === "CS") {
        allRequiredInputsAreValid = sousCompte !== "first";
      }

      //check if from and to date are not null and bq/cs select option not empty
      if (allRequiredInputsAreValid) {
        /**
         * invoices array for bq filtre
         * @type {*[]}
         */
        let invoicesBqCs = invoices;

        const date1 = new Date(`${fromDate.value}T00:00:00.000Z`);
        const date2 = new Date(`${toDate.value}T00:00:00.000Z`);

        if (date1 > date2) {
          setMsgErrorDate("La date de fin doit être supérieure ou égale à la date de début");
        } else {
          window.$("#modalDateExportAllInvoices").modal("hide");
          setProccessing(true);
          setLoaded(false);
          if (!exportCsv) window.$("#modalExportJounalPDF").modal("show");
  
          const m1 = parseInt(moment(date1).format("MM"));
          const m2 = parseInt(moment(date2).format("MM"));

          if (m1 === m2) {
            monthsSelected.push(m1);
          } else {
            for (let mth = m1; mth <= m2; mth++) {
              monthsSelected.push(mth);
            }
          }

          //filter invoices by creation date, only for FA,DAN,DO and FV
          const filteredInvs = invoices.filter(invoice =>
            new Date(invoice.created_at) >= date1 &&
            new Date(invoice.created_at) <= date2
          );

          //filter pieces by creation date
          const filteredPieces = pieces.filter(piece =>
            new Date(piece.created_at) >= date1 &&
            new Date(piece.created_at) <= date2
          );

          /**
           * prepare data to send to pdf/csv generator
           * @type {{FV: *[], CS: *[], months: *[], OD: *[], FA: *[], type, RAN: *[], BQ: *[]}}
           */
          const data_invs = {
            type: typeInv.value,
            FA: [],
            FV: [],
            BQ: [],
            CS: [],
            RAN: [],
            OD: [],
            months: monthsSelected,
          };
  
          // Process FA invoices
          const invsFA = filteredInvs.filter(invoice => getCodeCores("FA").includes(invoice.type));
          data_invs.FA = invsFA.map(invoice => {
            try {
              const flux = getEcEcoV2(invoice);
              const flux2 = getPieceLierV2(invoice);
              return flux2 ? [flux, flux2] : [flux];
            } catch (e) {
              console.error("Error processing FA invoice:", e);
              return [];
            }
          }).flat();
  
          // Process FV invoices
          const invsFV = filteredInvs.filter(invoice => getCodeCores("FV").includes(invoice.type));
          data_invs.FV = invsFV.map(invoice => {
            try {
              const flux = getEcEcoV2(invoice);
              const flux2 = getPieceLierV2(invoice);
              return flux2 ? [flux, flux2] : [flux];
            } catch (e) {
              console.error("Error processing FV invoice:", e);
              return [];
            }
          }).flat();

          // Process RAN pieces
          filteredPieces.forEach(piece => {
            if (piece.journal === getCodeCores("RAN")) {
              try {
                const flux = getPieceEc(piece);
                if (flux) data_invs.RAN.push(flux);
              } catch (e) {
                console.error("Error processing RAN piece:", e);
              }
            }
          });

          // Process OD pieces
          filteredPieces.forEach(piece => {
            if (piece.journal === getCodeCores("OD")) {
              try {
                const flux = getPieceEc(piece);
                if (flux) data_invs.OD.push(flux);
              } catch (e) {
                console.error("Error processing OD piece:", e);
              }
            }
          });

          // Process BQ invoices [OLD WAY]
          // invoicesBqCs.forEach(invoice => {
          //   let payedAmounts = 0;
          //   let condition = false;
          //   invoice.payment.forEach((payment, i) => {
          //         /**
          //          * invoice payment created at date
          //          * @type {Date}
          //          */
          //         let invoicePaymentCreatedAtDate = new Date(payment.created_at);
          //
          //         if (invoicePaymentCreatedAtDate >= date1 && invoicePaymentCreatedAtDate <= date2) {
          //           if (sousCompte === "allSousCompteBq" || typeInv.value === "all") {
          //             if ([2, 3].includes(payment.status.id))
          //               condition = isBqSousCompte(payment.payment_account?.code);
          //
          //           } else {
          //             if ([2, 3].includes(payment.status.id))
          //               condition = payment.payment_account?.code === sousCompte;
          //           }
          //
          //           if ([2, 3].includes(payment.status.id) && condition) {
          //             payedAmounts += parseFloat(payment.payed_amount || 0);
          //
          //             const totalFluxFin = (i === 0 && payment.status.id === 2)
          //                 ? invoice.total_ttc
          //                 : parseFloat(invoice.total_ttc || 0) - payedAmounts;
          //
          //             const supplierAccount = invoice.type === "achat" ? "4411000" : invoice.type === "vente" ? "34210000" : "4411000";
          //             const invoiceType = invoice.type;
          //
          //             const elt = {
          //               date_creation: moment(payment.created_at).format("DD/MM/YYYY"),
          //               no_piece: invoice.type.charAt(0) + invoice.id,
          //               compte_fournisseur: supplierAccount,
          //               sous_compte: invoice.client.account?.code || '',
          //               payment_account: payment.payment_account?.code || '',
          //               banquePaymentOption: payment.banquePaymentOption || '',
          //               chequeId: payment.chequeId || '',
          //               libelle_fournisseur: invoice.client.companyName || '',
          //               invoice_type: invoiceType,
          //               total_ttc: Number(totalFluxFin).toFixed(2),
          //             };
          //             data_invs.BQ.push(elt);
          //           }
          //         }
          //       }
          //   )
          // });

          // Process BQ transactions
          invoicesBqCs.forEach(invoice => {
            let payedAmounts = 0;
            let letTotalhtFluxFin = 0;
            let invoice_type = "";
            let le_compte_fournisseur = "";
            let conditionBq = false;
            let total_ttc = 0;

            invoice.payment.forEach((payment, i) => {
                  /**
                   * invoice payment created at date
                   * @type {Date}
                   */
                  let invoicePaymentCreatedAtDate = new Date(payment.created_at);
                  payedAmounts += parseFloat(payment.payed_amount);

                  if ([2, 3].includes(payment.status.id) && invoicePaymentCreatedAtDate >= date1 && invoicePaymentCreatedAtDate <= date2) {

                    if (sousCompte === "allSousCompteBq" || typeInv.value === "all") {
                      conditionBq = isBqSousCompte(payment.payment_account?.code);
                    } else {
                      conditionBq = payment.payment_account?.code === sousCompte;
                    }

                    if (conditionBq) {
                      // rendre les mnt négative si facture d'avoir
                      let operator = 0;

                      if (i === 0 && payment.status.id === 2) {
                        letTotalhtFluxFin = invoice.total_ttc;
                      } else if (i > 0 && payment.status.id === 2) {
                        //condition 2, is paid from the x iteration
                        letTotalhtFluxFin =
                            parseFloat(invoice.total_ttc) - payedAmounts;
                      } else {
                        //condition 3, if not paid yet
                        letTotalhtFluxFin = payment.payed_amount;
                      }

                      if (invoice.type === "achat") {
                        operator = 1;
                        total_ttc = invoice.total_ttc;
                        invoice_type = "achat";
                        le_compte_fournisseur = "4411000";
                      } else if (invoice.type === "vente" || invoice.type === "avoir") {
                        operator = invoice.type === "avoir" ? -1 : 1;
                        total_ttc = invoice.total_ttc;
                        invoice_type = "vente";
                        le_compte_fournisseur = "34210000";
                      } else if (invoice.type === "depense") {
                        operator = 1;
                        total_ttc = invoice.total_ttc;
                        invoice_type = "depense";
                        le_compte_fournisseur = "4411000";
                      }

                      let elt = {
                        date_creation: moment(payment.created_at).format(
                            "DD/MM/YYYY"
                        ),
                        no_piece:
                            invoice.type === "avoir"
                                ? "FAV" + "" + invoice.id
                                : invoice.type.charAt(0) + "" + invoice.id,
                        compte_fournisseur: le_compte_fournisseur,
                        sous_compte: invoice.client.account.code,
                        payment_account: payment.payment_account.code,
                        banquePaymentOption: payment.banquePaymentOption,
                        chequeId: payment.chequeId,
                        libelle_fournisseur: invoice.client.companyName,
                        invoice_type: invoice_type,
                        total_ttc: Number(letTotalhtFluxFin).toFixed(2) * operator,
                      };
                      data_invs.BQ.push(elt);
                    }
                  }
                }
            )
          });

          // get related bq added in piece module
          /**
           * @type {boolean}
           */
          let condition=false;

          filteredPieces.map((piece) => {
            if( sousCompte==="allSousCompteBq" || typeInv.value === "all"){
              condition= isBqSousCompte(piece['debit_credit'][0]["account"]["code"]);
            }else{
              condition= piece['debit_credit'][0]["account"]["code"] === sousCompte;
            }

            if (condition) {
              let flux = getPieceEc(piece, true);
              if (flux != null) {
                data_invs.BQ.push(flux);
              }
            }
          });

          // Process CS transactions
          invoicesBqCs.forEach(invoice => {
            let payedAmounts = 0;
            let letTotalhtFluxFin = 0;
            let invoice_type = "";
            let le_compte_fournisseur = "";
            let conditionCs = false;
            let total_ttc = 0;

            invoice.payment.forEach((payment, i) => {
              console.log("payment: ",payment)
              console.log("i: ",i)
                  /**
                   * invoice payment created at date
                   * @type {Date}
                   */
                  let invoicePaymentCreatedAtDate = new Date(payment.created_at);
                  payedAmounts += parseFloat(payment.payed_amount);

                  if ([2, 3].includes(payment.status.id) && invoicePaymentCreatedAtDate >= date1 && invoicePaymentCreatedAtDate <= date2) {

                    if (sousCompte === "allSousCompteCs" || typeInv.value === "all") {
                      conditionCs = isCsSousCompte(payment.payment_account?.code);
                    } else {
                      conditionCs = payment.payment_account?.code === sousCompte;
                    }

                    if (conditionCs) {
                      // rendre les mnt négative si facture d'avoir
                      let operator = 0;

                      if (i === 0 && payment.status.id === 2) {
                        letTotalhtFluxFin = invoice.total_ttc;
                      } else if (i > 0 && payment.status.id === 2) {
                        //condition 2, is paid from the x iteration
                        letTotalhtFluxFin =
                            parseFloat(invoice.total_ttc) - payedAmounts;
                      } else {
                        //condition 3, if not paid yet
                        letTotalhtFluxFin = payment.payed_amount;
                      }

                      if (invoice.type === "achat") {
                        operator = 1;
                        total_ttc = invoice.total_ttc;
                        invoice_type = "achat";
                        le_compte_fournisseur = "4411000";
                      } else if (invoice.type === "vente" || invoice.type === "avoir") {
                        operator = invoice.type === "avoir" ? -1 : 1;
                        total_ttc = invoice.total_ttc;
                        invoice_type = "vente";
                        le_compte_fournisseur = "34210000";
                      } else if (invoice.type === "depense") {
                        operator = 1;
                        total_ttc = invoice.total_ttc;
                        invoice_type = "depense";
                        le_compte_fournisseur = "4411000";
                      }

                      let elt = {
                        date_creation: moment(payment.created_at).format(
                            "DD/MM/YYYY"
                        ),
                        no_piece:
                            invoice.type === "avoir"
                                ? "FAV" + "" + invoice.id
                                : invoice.type.charAt(0) + "" + invoice.id,
                        compte_fournisseur: le_compte_fournisseur,
                        sous_compte: invoice.client.account.code,
                        payment_account: payment.payment_account.code,
                        banquePaymentOption: payment.banquePaymentOption,
                        chequeId: payment.chequeId,
                        libelle_fournisseur: invoice.client.companyName,
                        invoice_type: invoice_type,
                        total_ttc: Number(letTotalhtFluxFin).toFixed(2) * operator,
                      };
                      data_invs.CS.push(elt);
                    }
                  }
                }
            )
          });

          // get related cs added in piece module
          filteredPieces.map((piece) => {
            if( sousCompte==="allSousCompteCs" || typeInv.value === "all" ){
              condition= isCsSousCompte(piece['debit_credit'][0]["account"]["code"]);
            }else{
              condition= piece['debit_credit'][0]["account"]["code"] === sousCompte;
            }

            if (condition) {
              let flux = getPieceEc(piece, true);
              if (flux != null) {
                data_invs.CS.push(flux);
              }
            }
          })

          if (exportCsv) {
            /**
             *
             * @type {string}
             */
            const monthRange = ` entre le ${moment(date1).format("DD/MM/YYYY")} et le ${moment(date2).format("DD/MM/YYYY")} `;

            //handle is bq sc or allbq
            if (isBqSousCompte(sousCompte)) {
              exportData(data_invs.BQ, "BQ", `Journal comptable de la banque ${sousCompte}`, monthRange);
            } else if (sousCompte === "allSousCompteBq") {
              exportData(data_invs.BQ, "BQ", "Journal comptable de la banque", monthRange);
            }

            //handle is cs sc or allcs
            if (isCsSousCompte(sousCompte)) {
              exportData(data_invs.CS, "CS", `Journal comptable de la banque ${sousCompte}`);
            } else if (sousCompte === "allSousCompteCs") {
              exportData(data_invs.CS, "CS", "Journal comptable de la banque", monthRange);
            }

            //handle FA,FV,RAN,OD
            if (typeInv.value === "FA") {
              exportData(data_invs.FA, "FA", "Journal comptable des achats", monthRange);
            } else if (typeInv.value === "FV") {
              exportData(data_invs.FV, "FV", "Journal comptable des ventes", monthRange);
            } else if (typeInv.value === "RAN") {
              exportData(data_invs.RAN, "RAN", "Journal comptable du Report à nouveau", monthRange);
            } else if (typeInv.value === "OD") {
              exportData(data_invs.OD, "OD", "Journal comptable des opérations diverses", monthRange);
            }
            //handle all
            else if (typeInv.value === "all") {
              exportData(data_invs.FV, "FV", "Journal comptable des ventes", monthRange,"journal des ventes");
              exportData(data_invs.FA, "FA", "Journal comptable des achats", monthRange,"journal des achats");
              exportData(data_invs.BQ, "BQ", "Journal comptable de la banque", monthRange,"journal de la banque");
              exportData(data_invs.CS, "CS", "Journal comptable de la caisse", monthRange,"journal de la caisse");
              exportData(data_invs.RAN, "RAN", "Journal comptable du Report à nouveau", monthRange,"journal du Report à nouveau");
              exportData(data_invs.OD, "OD", "Journal comptable des opérations diverses", monthRange,"journal des opérations diverses");
            }

          }else{
            setInvsDataFiltered(JSON.stringify(data_invs));
            setProccessing(false);
            setLoaded(true);
          }
          console.log(data_invs);

        }
      } else {
        toast.error(t("Remplissez tous les champs !"), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };
  

  const ExportAllJournalToPDF = ({ data = null }) => {
    const data_pdf = JSON.parse(data);
    const static_months = {
      1: t("janvier"),
      2: t("février"),
      3: t("mars"),
      4: t("avril"),
      5: t("mai"),
      6: t("juin"),
      7: t("juillet"),
      8: t("août"),
      9: t("septembre"),
      10: t("octobre"),
      11: t("novembre"),
      12: t("décembre"),
    };

    const codeFactures = {
      FA: "Achats",
      FV: "Ventes",
      BQ: "BANQUE",
      CS: "CAISSE",
      RAN: "Raport à nouveau",
      OD: "Opération diverse",
    };
    const subCodeFactures = {
      FA: "ACH",
      FV: "VTE",
      BQ: "BQ",
      CS: "CS",
      RAN: "RAN",
      OD: "OD",
    };
    if (data_pdf != null) {
      let months = data_pdf["months"];

      if (data_pdf["type"] !== "all") {
        let data_months = {};
        for (let m = 0; m < months.length; m++) {
          let data_month = {};
          let temp = data_pdf[data_pdf["type"]].filter(
            (v) =>
              parseInt(v.date_creation.split("/")[1]) === parseInt(months[m])
          );
          data_month[data_pdf["type"]] = temp;

          data_months[`${months[m]}`] = data_month;
        }
        return (
          <Document>
            {months.map((m) => {
              if (["BQ", "CS"].includes(data_pdf["type"])) {
                return (
                  <JournalPage
                    data2={data_months[`${m}`][data_pdf["type"]]}
                    codeFacture={codeFactures[data_pdf["type"]]}
                    subCodeFC={subCodeFactures[data_pdf["type"]]}
                    is_custom_month={true}
                    custom_month={static_months[m]}
                  />
                );
              }
              return (
                <JournalPage
                  data={data_months[`${m}`][data_pdf["type"]]}
                  codeFacture={codeFactures[data_pdf["type"]]}
                  subCodeFC={subCodeFactures[data_pdf["type"]]}
                  is_custom_month={true}
                  custom_month={static_months[m]}
                />
              );
            })}
          </Document>
        );
      } else {
        let data_months = {};
        for (let m = 0; m < months.length; m++) {
          let data_month = {};
          let temp = data_pdf["FA"].filter(
            (v) =>
              parseInt(v.date_creation.split("/")[1]) === parseInt(months[m])
          );
          data_month["FA"] = temp;
          let temp2 = data_pdf["FV"].filter(
            (v) =>
              parseInt(v.date_creation.split("/")[1]) === parseInt(months[m])
          );
          data_month["FV"] = temp2;

          let temp3 = data_pdf["RAN"].filter(
            (v) =>
              parseInt(v.date_creation.split("/")[1]) === parseInt(months[m])
          );
          data_month["RAN"] = temp3;

          let temp4 = data_pdf["OD"].filter(
            (v) =>
              parseInt(v.date_creation.split("/")[1]) === parseInt(months[m])
          );
          data_month["OD"] = temp4;

          let temp5 = data_pdf["BQ"].filter(
            (v) =>
              parseInt(v.date_creation.split("/")[1]) === parseInt(months[m])
          );
          data_month["BQ"] = temp5;

          let temp6 = data_pdf["CS"].filter(
            (v) =>
              parseInt(v.date_creation.split("/")[1]) === parseInt(months[m])
          );
          data_month["CS"] = temp6;

          data_months[`${months[m]}`] = data_month;
        }
        return (
          <Document>
            {months.map((m) => {
              return (
                <>
                  <JournalPage
                    data={data_months[`${m}`]["FA"]}
                    codeFacture="Achats"
                    subCodeFC="ACH"
                    is_custom_month={true}
                    custom_month={static_months[m]}
                  />
                  <JournalPage
                    data={data_months[`${m}`]["FV"]}
                    codeFacture="Ventes"
                    subCodeFC="VTE"
                    is_custom_month={true}
                    custom_month={static_months[m]}
                  />
                  <JournalPage
                    data2={data_months[`${m}`]["BQ"]}
                    codeFacture="BANQUE"
                    subCodeFC="BQ"
                    is_custom_month={true}
                    custom_month={static_months[m]}
                  />
                  <JournalPage
                    data2={data_months[`${m}`]["CS"]}
                    codeFacture="CAISSE"
                    subCodeFC="CS"
                    is_custom_month={true}
                    custom_month={static_months[m]}
                  />
                  <JournalPage
                    data={data_months[`${m}`]["RAN"]}
                    codeFacture="Raport à nouveau"
                    subCodeFC="RAN"
                    is_custom_month={true}
                    custom_month={static_months[m]}
                  />
                  <JournalPage
                    data={data_months[`${m}`]["OD"]}
                    codeFacture="Opération diverses"
                    subCodeFC="OD"
                    is_custom_month={true}
                    custom_month={static_months[m]}
                  />
                </>
              );
            })}
          </Document>
        );
      }
    }
  };

  return (
    <>
      <ToastContainer />
      <div
        className="modal fade"
        id="exampleModalFullscreen"
        tabIndex="-1"
        aria-labelledby="exampleModalFullscreenLabel"
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-4" id="exampleModalFullscreenLabel">
                Journal {" " + chooseMonth + "/" + currentYear}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <ToastContainer />

              <div className="container">
                <div className="row">
                  <ToastContainer />

                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="custom-switch form-switch">
                            <input
                              type="checkbox"
                              name="custom-switch-checkbox2"
                              className="custom-switch-input"
                              checked={filterOption === "FA"}
                              onChange={() => {
                                setSousCompte("");
                                setFilterOption("FA");
                              }}
                            />
                            <span className="custom-switch-indicator custom-switch-indicator-lg"></span>
                            <span className="custom-switch-description">
                              {t("Facture d'achat")}
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 d-flex grid gap-3 flex-row-reverse">
                        {/* {filterOption === 'FA' ? (<button onClick={()=> {
                                                    printJournal("FA");
                                                }} className='btn btn-info' style={{height: 37}}><span className="fe fe-download"> </span> {t('Print')}</button>):null}
                                             */}
                        {filterOption === "FA" && ecsLoaded === 0 ? (
                          <>
                            <PDFDownloadLink
                              document={
                                <JournalPDF
                                  data={[...invoicesEcs]}
                                  codeFacture="Achats"
                                  subCodeFC="ACH"
                                />
                              }
                              fileName="journal-facture-achat.pdf"
                              className="btn btn-info"
                              style={{ height: 38 }}
                            >
                              {({ blob, url, loading, error }) =>
                                loading ? (
                                  t("Loading document...")
                                ) : (
                                  <>
                                    <span className="fe fe-download"> </span>{" "}
                                    {t("Télécharger PDF")}
                                  </>
                                )
                              }
                            </PDFDownloadLink>
                            <button
                              onClick={exportCsvEc}
                              className={"btn btn-info"}
                              style={{ height: 38 }}
                            >
                              <span className="fe fe-download">
                                {t("Télécharger CSV")}
                              </span>
                            </button>
                          </>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="custom-switch form-switch">
                            <input
                              type="checkbox"
                              name="custom-switch-checkbox2"
                              className="custom-switch-input"
                              checked={filterOption === "FV"}
                              onChange={() => {
                                setSousCompte("");
                                setFilterOption("FV");
                              }}
                            />
                            <span className="custom-switch-indicator custom-switch-indicator-lg"></span>
                            <span className="custom-switch-description">
                              {t("Facture de vente")}
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 d-flex grid gap-3 flex-row-reverse">
                        {filterOption === "FV" && ecsLoaded === 0 ? (
                          <>
                            <PDFDownloadLink
                              document={
                                <JournalPDF
                                  data={[...invoicesEcs]}
                                  codeFacture="Ventes"
                                  subCodeFC="VTE"
                                />
                              }
                              fileName="journal-des-ventes.pdf"
                              className="btn btn-info"
                              style={{ height: 38 }}
                            >
                              {({ blob, url, loading, error }) =>
                                loading ? (
                                  t("Loading document...")
                                ) : (
                                  <>
                                    <span className="fe fe-download"> </span>{" "}
                                    {t("Télécharger PDF")}
                                  </>
                                )
                              }
                            </PDFDownloadLink>

                            <button
                              onClick={exportCsvEc}
                              className={"btn btn-info"}
                              style={{ height: 38 }}
                            >
                              <span className="fe fe-download">
                                {t("Télécharger CSV")}
                              </span>
                            </button>

                          </>
                        ) : null}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="custom-switch form-switch">
                            <input
                              type="checkbox"
                              name="custom-switch-checkbox2"
                              className="custom-switch-input"
                              checked={getBqSousCompte}
                              onChange={() => {
                                setSousCompte("");
                                setGetBqSousCompte(!getBqSousCompte);
                                if(getCsSousCompte && !getBqSousCompte)
                                  setGetCsSousCompte(false);
                                setFilterOption("BQ");
                              }}
                            />
                            <span className="custom-switch-indicator custom-switch-indicator-lg"></span>
                            <span className="custom-switch-description">
                              {t("Banque")}
                            </span>
                          </label>

                          <div
                            className="bqSousComptesWrapper"
                            style={{
                              display: getBqSousCompte ? "block" : "none",
                            }}
                          >
                            {sousComptes.map((account) => (
                              <div className="singleBqSousCompte">
                                <label className="custom-switch form-switch">
                                  <input
                                    type="radio"
                                    name="custom-switch-radio1"
                                    className="custom-switch-input"
                                    checked={sousCompte === account.code}
                                    onChange={() => {
                                      setSousCompte(account.code);
                                      setFilterOption(account.code);
                                    }}
                                  />
                                  <span class="custom-switch-indicator custom-switch-indicator-md"></span>
                                  <span class="custom-switch-description">
                                    {account.code + " - " + account.name}
                                  </span>
                                </label>
                              </div>
                            ))}
                            <div className="singleBqSousCompte">
                              <label className="custom-switch form-switch">
                                <input
                                  type="checkbox"
                                  name="custom-switch-checkbox2"
                                  className="custom-switch-input"
                                  checked={
                                    filterOption === "ALLBQ" &&
                                    sousCompte === "allSousCompteBq"
                                  }
                                  onChange={() => {
                                    setSousCompte("allSousCompteBq");
                                    setFilterOption("ALLBQ");
                                  }}
                                />
                                <span className="custom-switch-indicator custom-switch-indicator-md"></span>
                                <span className="custom-switch-description">
                                  Tous les sous comptes
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 d-flex grid gap-3 flex-row-reverse">
                        {/*{filterOption === 'BQ' && ecsLoaded === 0 ? (*/}
                        {(filterOption.substring(0, 4) === "5141" ||
                          sousCompte === "allSousCompteBq") &&
                        ecsLoaded === 0 ? (
                          <>
                            <PDFDownloadLink
                              document={
                                <JournalPDF
                                  data2={[...invoicesEcsFf]}
                                  codeFacture="BANQUE"
                                  subCodeFC="BQ"
                                />
                              }
                              fileName="journal-de-la-banque.pdf"
                              className="btn btn-info"
                              style={{ height: 38 }}
                            >
                              {({ blob, url, loading, error }) =>
                                loading ? (
                                  t("Loading document...")
                                ) : (
                                  <>
                                    <span className="fe fe-download"> </span>{" "}
                                    {t("Télécharger PDF")}
                                  </>
                                )
                              }
                            </PDFDownloadLink>
                            <button
                              onClick={exportCsvEc}
                              className={"btn btn-info"}
                              style={{ height: 38 }}
                            >
                              <span className="fe fe-download">
                                {t("Télécharger CSV")}
                              </span>
                            </button>
                          </>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="custom-switch form-switch">
                            <input
                                type="checkbox"
                                name="custom-switch-checkbox2"
                                className="custom-switch-input"
                                checked={getCsSousCompte}
                                onChange={() => {
                                  setSousCompte("");
                                  setGetCsSousCompte(!getCsSousCompte);
                                  if(getBqSousCompte && !getCsSousCompte)
                                    setGetBqSousCompte(false);
                                  setFilterOption("CS");
                                }}
                            />
                            <span className="custom-switch-indicator custom-switch-indicator-lg"></span>
                            <span className="custom-switch-description">
                              {t("Caisse")}
                            </span>
                          </label>

                          <div
                              className="bqSousComptesWrapper"
                              style={{
                                display: getCsSousCompte ? "block" : "none",
                              }}
                          >
                            {sousComptesCs.map((account) => (
                                <div className="singleBqSousCompte">
                                  <label className="custom-switch form-switch">
                                    <input
                                        type="radio"
                                        name="custom-switch-radio1"
                                        className="custom-switch-input"
                                        checked={sousCompte === account.code}
                                        onChange={() => {
                                          setSousCompte(account.code);
                                          setFilterOption(account.code);
                                        }}
                                    />
                                    <span class="custom-switch-indicator custom-switch-indicator-md"></span>
                                    <span class="custom-switch-description">
                                    {account.code + " - " + account.name}
                                  </span>
                                  </label>
                                </div>
                            ))}
                            <div className="singleBqSousCompte">
                              <label className="custom-switch form-switch">
                                <input
                                    type="checkbox"
                                    name="custom-switch-checkbox2"
                                    className="custom-switch-input"
                                    checked={
                                        filterOption === "ALLCS" &&
                                        sousCompte === "allSousCompteCs"
                                    }
                                    onChange={() => {
                                      setSousCompte("allSousCompteCs");
                                      setFilterOption("ALLCS");
                                    }}
                                />
                                <span className="custom-switch-indicator custom-switch-indicator-md"></span>
                                <span className="custom-switch-description">
                                  Tous les sous comptes
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 d-flex grid gap-3 flex-row-reverse">
                        {(filterOption.substring(0, 4) === "5161" ||
                            sousCompte === "allSousCompteCs") &&
                        ecsLoaded === 0 ? (
                          <>
                            <PDFDownloadLink
                              document={
                                <JournalPDF
                                  data2={[...invoicesEcsFf]}
                                  codeFacture="CAISSE"
                                  subCodeFC="CS"
                                />
                              }
                              fileName="journal-de-la-caisse.pdf"
                              className="btn btn-info"
                              style={{ height: 38 }}
                            >
                              {({ blob, url, loading, error }) =>
                                loading ? (
                                  t("Loading document...")
                                ) : (
                                  <>
                                    <span className="fe fe-download"> </span>{" "}
                                    {t("Télécharger PDF")}
                                  </>
                                )
                              }
                            </PDFDownloadLink>

                            <button
                              onClick={exportCsvEc}
                              className={"btn btn-info"}
                              style={{ height: 38 }}
                            >
                              <span className="fe fe-download">
                                {t("Télécharger CSV")}
                              </span>
                            </button>
                          </>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div class="form-group">
                          <label className="custom-switch form-switch">
                            <input
                              type="checkbox"
                              name="custom-switch-checkbox2"
                              className="custom-switch-input"
                              checked={filterOption === "RAN"}
                              onChange={() => {
                                setSousCompte("");
                                setFilterOption("RAN");
                              }}
                            />
                            <span class="custom-switch-indicator custom-switch-indicator-lg"></span>
                            <span class="custom-switch-description">
                              Report à nouveau
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 d-flex grid gap-3 flex-row-reverse">
                        {filterOption === "RAN" && ecsLoaded === 0 ? (
                          <>
                            <PDFDownloadLink
                              document={
                                <JournalPDF
                                  data={[...invoicesEcs]}
                                  codeFacture="Raport à nouveau"
                                  subCodeFC="RAN"
                                />
                              }
                              fileName="journal-raport-a-nouveau.pdf"
                              className="btn btn-info"
                              style={{ height: 38 }}
                            >
                              {({ blob, url, loading, error }) =>
                                loading ? (
                                  t("Loading document...")
                                ) : (
                                  <>
                                    <span className="fe fe-download"> </span>{" "}
                                    {t("Télécharger PDF")}
                                  </>
                                )
                              }
                            </PDFDownloadLink>
                            <button
                              onClick={exportCsvEc}
                              className={"btn btn-info"}
                              style={{ height: 38 }}
                            >
                              <span className="fe fe-download">
                                {t("Télécharger CSV")}
                              </span>
                            </button>
                          </>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div class="form-group">
                          <label className="custom-switch form-switch">
                            <input
                              type="checkbox"
                              name="custom-switch-checkbox2"
                              className="custom-switch-input"
                              checked={filterOption === "OD"}
                              onChange={() => {
                                setSousCompte("");
                                setFilterOption("OD");
                              }}
                            />
                            <span class="custom-switch-indicator custom-switch-indicator-lg"></span>
                            <span class="custom-switch-description">
                              Opération diverses
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 d-flex grid gap-3 flex-row-reverse">
                        {filterOption === "OD" && ecsLoaded === 0 ? (
                          <>
                            <PDFDownloadLink
                              document={
                                <JournalPDF
                                  data={[...invoicesEcs]}
                                  codeFacture="Opération diverses"
                                  subCodeFC="OD"
                                />
                              }
                              fileName="journal-Opération-diverses.pdf"
                              className="btn btn-info"
                              style={{ height: 38 }}
                            >
                              {({ blob, url, loading, error }) =>
                                loading ? (
                                  t("Loading document...")
                                ) : (
                                  <>
                                    <span className="fe fe-download"> </span>{" "}
                                    {t("Télécharger PDF")}
                                  </>
                                )
                              }
                            </PDFDownloadLink>
                            <button
                              onClick={exportCsvEc}
                              className={"btn btn-info"}
                              style={{ height: 38 }}
                            >
                              <span className="fe fe-download">
                                {t("Télécharger CSV")}
                              </span>
                            </button>
                          </>
                        ) : null}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="custom-switch form-switch">
                            <input
                              type="checkbox"
                              name="custom-switch-checkbox2"
                              className="custom-switch-input"
                              checked={filterOption === "all"}
                              onChange={() => {
                                setFilterOption("all");
                                setEcsLoaded(1);
                                preparAllJournals();
                              }}
                            />
                            <span className="custom-switch-indicator custom-switch-indicator-lg"></span>
                            <span className="custom-switch-description">
                              Exporter le journal du mois {chooseMonth.toString()+"/"+currentYear.toString()}
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 d-flex grid gap-3 flex-row-reverse">
                        {filterOption === "all" ? (
                          loadingFA &&
                          loadingFV &&
                          loadingBQ &&
                          loadingCS &&
                          loadingRAN &&
                          loadingOD ? (
                            <>
                              <PDFDownloadLink
                                key={"all"}
                                document={
                                  <ExportAllJournals
                                    bq={[...jbq]}
                                    cs={[...jcs]}
                                    fa={[...jfa]}
                                    fv={[...jfv]}
                                    ran={[...jran]}
                                    od={[...jod]}
                                  />
                                }
                                fileName="journal.pdf"
                                className="btn btn-info"
                                style={{ height: 38 }}
                              >
                                {({ blob, url, loading, error }) =>
                                  loading ? (
                                    t("Loading document...")
                                  ) : (
                                    <>
                                      <span className="fe fe-download"> </span>{" "}
                                      {t("Télécharger PDF")}
                                    </>
                                  )
                                }
                              </PDFDownloadLink>

                              <button
                                onClick={exportCsvEc}
                                className={"btn btn-info"}
                                style={{ height: 38 }}
                              >
                                <span className="fe fe-download">
                                  {t("Télécharger CSV")}
                                </span>
                              </button>
                            </>
                          ) : (
                            <div
                              class="spinner-border text-primary me-2"
                              role="status"
                            >
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          )
                        ) : null}
                      </div>
                    </div>
                    <br />
                    <br />
                  </div>
                </div>

                <center>
                  <div
                    className="spinner-border text-primary me-2"
                    role="status"
                    style={{ display: ecsLoaded === 0 ? "none" : "block" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </center>
                <div
                  className="ecWrapper"
                  style={{ display: notEmpty === 1 ? "block" : "none" }}
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 journalOverflowFix">
                        <table
                          className="table border table-hover"
                          id="journal"
                        >
                          <thead className="table-primary">
                            <tr>
                              <th scope="col">Date de Facture</th>
                              <th scope="col">n° piéce</th>
                              
                              <th scope="col">N° compte</th>
                              <th scope="col">sous compte</th>
                              <th scope="col">libellé écriture</th>
                              <th scope="col">débit</th>
                              <th scope="col">crédit</th>
                            </tr>
                          </thead>

                          <tbody>
                            {invoicesEcs?.map((flux) => {
                              if (flux.from === "invoice_module") {
                                return (
                                  <tr>
                                    <th scope="col">{flux.date_creation}</th>
                                    <th scope="col">{flux.no_piece}</th>

                                    <th scope="col">
                                      <span>{flux.compte_fournisseur}</span>
                                      <br />
                                      {flux.compte_tva?.map((tva) => {
                                        return (
                                          <span>
                                            {tva}
                                            <br />
                                          </span>
                                        );
                                      })}
                                      {flux?.compte_compte_de_charge?.map(
                                        (compte_de_charge) => {
                                          return (
                                            <span>
                                              {compte_de_charge}
                                              <br />
                                            </span>
                                          );
                                        }
                                      )}
                                    </th>
                                    <th scope="col">{flux.sous_compte}</th>
                                    <th scope="col">
                                      {flux.libelle_fournisseur}
                                    </th>

                                    <th scope="col">
                                      {flux.invoice_type === "vente"
                                        ? Number(flux.total_ttc).toFixed(2)
                                        : flux?.total_ht_et_tva?.map(
                                            (total_ht_et_tva, elt = 0) => {
                                              if (elt === 0) {
                                                elt++;
                                                return (
                                                  <div>
                                                    <br />
                                                  </div>
                                                );
                                              }
                                              return (
                                                <div> {Number(total_ht_et_tva).toFixed(2)} </div>
                                              );
                                            }
                                          )}
                                    </th>
                                    <th scope="col">
                                      {flux.invoice_type === "vente"
                                        ? flux?.total_ht_et_tva?.map(
                                            (total_ht_et_tva, elt = 0) => {
                                              if (elt === 0) {
                                                elt++;
                                                return (
                                                  <div>
                                                    <br />
                                                  </div>
                                                );
                                              }
                                              return (
                                                <div> {Number(total_ht_et_tva).toFixed(2)} </div>
                                              );
                                            }
                                          )
                                        : Number(flux.total_ttc).toFixed(2)}
                                    </th>
                                  </tr>
                                );
                              } else {
                                console.log("selected flux :  ", flux);
                                return (
                                  <tr>
                                    <th scope="col">{flux.date_creation}</th>
                                    <th scope="col">{flux.no_piece}</th>
                                    <th scope="col">
                                      <div>{flux.compte_fournisseur}</div>
                                      <div>
                                        {flux?.accounts &&
                                          flux?.accounts[0]?.map((account) => {
                                            return <div> {account} </div>;
                                          })}

                                        {flux?.nature === 'is_bq_cs' ?
                                          <div> {flux?.sous_compte} </div>:null
                                        }
                                      </div>
                                    </th>
                                    <th scope="col">{"-"}</th>
                                    <th scope="col">
                                      {flux.libelle_fournisseur}
                                    </th>
                                    <th scope="col">
                                      {flux.from === "ocr_ec_module" ? (
                                        <p></p>
                                      ) : null}
                                      <div>
                                        {flux.debit &&
                                          flux.debit[0].map((d) => {
                                            return <div> {Number(d).toFixed(2)} </div>;
                                          })}
                                      </div>
                                    </th>
                                    <th scope={"col"}>
                                      {flux.from === "ocr_ec_module" ? (
                                        <p></p>
                                      ) : null}
                                      <div>
                                        {flux.credit &&
                                          flux.credit[0].map((c) => {
                                            return <div> {Number(c).toFixed(2)} </div>;
                                          })}
                                      </div>
                                    </th>
                                  </tr>
                                );
                              }
                            })}
                            {invoicesEcsFf.map((f) => {
                              if(f.isSousCompteBqCs){
                                return (
                                    <tr>
                                      <th scope="col">{f.date_creation}</th>
                                      <th scope="col">{f.no_piece}</th>
                                      <th scope="col">
                                        <div>{f.compte_fournisseur}</div>
                                        <div>
                                          {f?.accounts &&
                                              f?.accounts[0]?.map((account) => {
                                                return <div> {account} </div>;
                                              })}

                                          {f?.nature === 'is_bq_cs' ?
                                              <div> {f?.sous_compte} </div>:null
                                          }
                                        </div>
                                      </th>

                                      <th scope="col">{"-"}</th>
                                      <th scope="col">
                                        {f.libelle_fournisseur}
                                      </th>

                                      <th scope="col">
                                        <div>
                                          {f.debit &&
                                              f.debit[0].map((d) => {
                                                return <div> {Number(d).toFixed(2)} </div>;
                                              })}
                                        </div>
                                      </th>

                                      <th scope={"col"}>
                                        <div>
                                          {f.credit &&
                                              f.credit[0].map((c) => {
                                                return <div> {Number(c).toFixed(2)} </div>;
                                              })}
                                        </div>
                                      </th>

                                    </tr>
                                )
                              } else {
                                return (
                                    <tr>
                                      <th scope="col">{f.date_creation}</th>
                                      <th scope="col">{f.no_piece}</th>
                                      <th scope="col">
                                        <span>{f.compte_fournisseur}</span>
                                        <br/>
                                        <span>{f.payment_account}</span>
                                        <br/>
                                        <span>
                                      {f.banquePaymentOption === null
                                          ? ""
                                          : f.banquePaymentOption +
                                          (f.chequeId === null
                                              ? ""
                                              : " - " + f.chequeId)}
                                    </span>
                                        <br/>
                                        <br/>
                                      </th>
                                      <th scope="col">{f.sous_compte}</th>
                                      <th scope="col">
                                        {f.banquePaymentOption === null
                                            ? f.libelle_fournisseur
                                            : f.banquePaymentOption +
                                            (f.chequeId === null
                                                ? ""
                                                : " - " + f.chequeId)}
                                      </th>

                                      <th scope="col">
                                        {f.invoice_type === "vente" ? (
                                            <span>
                                        {" "}
                                              <br/> {Number(f.total_ttc).toFixed(2)}{" "}
                                      </span>
                                        ) : f.invoice_type === "achat" ? (
                                            <span> {Number(f.total_ttc).toFixed(2)} </span>
                                        ) : (
                                            <span> {Number(f.total_ttc).toFixed(2)} </span>
                                        )}
                                      </th>
                                      <th scope="col">
                                        {f.invoice_type === "vente" ? (
                                            Number(f.total_ttc).toFixed(2)
                                        ) : f.invoice_type === "achat" ? (
                                                <span>
                                        {" "}
                                                  <br/> {Number(f.total_ttc).toFixed}{" "}
                                      </span>
                                            ) :
                                            (
                                                <span>
                                        {" "}
                                                  <br/> {Number(f.total_ttc).toFixed(2)}{" "}
                                      </span>
                                            )}
                                      </th>
                                    </tr>
                                )

                              }
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  onClick={() => {
                    setFilterOption("");
                    setLoadingFA(null);
                    setLoadingFV(null);
                    setLoadingBQ(null);
                    setLoadingCS(null);
                    setJFA([]);
                    setJFV([]);
                    setJBQ([]);
                    setJCS([]);
                  }}
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="modalExportJounalPDF"
        aria-modal="true"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered text-center "
          role="document"
        >
          <div className="modal-content tx-size-sm">
            {proccesing ? (
              <div className="modal-body text-center p-4 pb-5">
                <i className="icon icon-clock fs-70 text-warning lh-1 my-5 d-inline-block"></i>
                <h4 className="text-warning tx-semibold">
                  {t("Traitement en cours!")}
                </h4>
                <p className="mg-b-20 mg-x-20">
                  {t("Patientez s'il-vous-plait")}
                </p>
              </div>
            ) : null}
            {loaded ? (
              <div className="modal-body text-center p-4 pb-5">
                <i className="icon icon-check fs-70 text-success lh-1 my-5 d-inline-block"></i>
                <h4 className="text-success tx-semibold">
                  {t("Généré avec succès!")}
                </h4>

                <PDFDownloadLink
                  document={
                    <ExportAllJournalToPDF
                      data={invsDataFiltered != null ? invsDataFiltered : null}
                    />
                  }
                  fileName="journal-comptable.pdf"
                  className="btn btn-success pd-x-25"
                  style={{ height: 38 }}
                >
                  {({ blob, url, loading, error }) =>
                    loading ? t("Loading document...") : t("Télécharger")
                  }
                </PDFDownloadLink>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modalDateExportAllInvoices"
        aria-modal="true"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered text-center "
          role="document"
        >
          <div className="modal-content tx-size-sm">
            <div className="modal-body text-center p-4 pb-5">

              <div class="form-group">
                <h3 htmlFor="exampleInputEmail1" className="requiredElt">
                  {t("Entre le")} *
                </h3>
                <input
                  type="date"
                  className="form-control"
                  id={"date-from"}
                  name={"date-from"}
                />
              </div>
              <div class="form-group">
                <h3 htmlFor="exampleInputEmail1" className="requiredElt">
                  {t("et le")} *
                </h3>
                <input
                  type="date"
                  className="form-control"
                  id={"date-to"}
                  name={"date-to"}
                />
              </div>
              <div class="form-group">
                <h3 htmlFor="exampleInputEmail1" className="requiredElt">
                  {t("Type")} *
                </h3>
                <select
                  id={"type-facture"}
                  ref={selectRef}
                  className="form-control"
                  onChange={(e) => {
                    if (e.target.value === "BQ") {
                      setGetBqSousCompte(true);
                      setGetCsSousCompte(false);
                    } else if (e.target.value === "CS") {
                      setGetBqSousCompte(false);
                      setGetCsSousCompte(true);
                    } else {
                      setGetBqSousCompte(false);
                      setGetCsSousCompte(false);
                    }
                  }}
                >
                  <option value={"all"}>{t("Tout")}</option>
                  <option value={"FA"}>{t("Facture d'achat")}</option>
                  <option value={"FV"}>{t("Facture de vente")}</option>
                  <option value={"BQ"}>{t("Banque")}</option>
                  <option value={"CS"}>{t("Caisse")}</option>
                  <option value={"RAN"}>{t("Report à nouveau")}</option>
                  <option value={"OD"}>{t("Opération diverses")}</option>
                </select>
              </div>

              <div
                class="form-group"
                style={{ display: getBqSousCompte ? "block" : "none" }}
              >
                <label htmlFor="exampleInputEmail1" className="requiredElt">
                  {t("Sous Compte")} *
                </label>
                <select
                  id={"type-facture-sous-compte"}
                  className="form-control"
                  onChange={(e) => {
                    setSousCompte(e.target.value);
                  }}
                  value={sousCompte}
                >
                  <option value={"first"}>
                    Veuillez sélectionner un sous compte
                  </option>
                  {sousComptes.map((account) => (
                    <option value={account.code}>
                      {account.code + " - " + account.name}
                    </option>
                  ))}
                  <option value="allSousCompteBq">Tous les sous comptes</option>
                </select>
              </div>

              <div
                  class="form-group"
                  style={{ display: getCsSousCompte ? "block" : "none" }}
              >
                <h3 htmlFor="exampleInputEmail1" className="requiredElt">
                  {t("Sous Compte")} *
                </h3>
                <select
                    id={"type-facture-sous-compte"}
                    className="form-control"
                    onChange={(e) => {
                      setSousCompte(e.target.value);
                    }}
                    value={sousCompte}
                >
                  <option value={"first"}>
                    Veuillez sélectionner un sous compte
                  </option>
                  {sousComptesCs.map((account) => (
                      <option value={account.code}>
                        {account.code + " - " + account.name}
                      </option>
                  ))}
                  <option value="allSousCompteCs">Tous les sous comptes</option>
                </select>
              </div>

              {msgErrorDate && msgErrorDate.length > 0 ? (
                <div class="alert alert-danger" role="alert">
                  <p>{msgErrorDate}</p>
                </div>
              ) : null}
              <button
                className="btn btn-primary pd-x-25"
                style={{ height: 38 }}
                onClick={exportAllInvoicesByDate}
              >
                {/*{t("Exporter")}*/}
                <i className="fa fa-download" style={ {fontSize:'25px'} }></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">


        <div className="main-container container-fluid">
          <div className="page-header">
            <h1 className="page-title breadcumpsHeader">Journal Comptable</h1>
            <div>
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="javascript:void(0)">Comptabilité</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">Journal Comptable de l'année , filtre et exportation</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="row" style={{ zIndex: 1 }}>
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className={"conatiner mb-5"}>
                  <div className={"row"}>
                    <div className={"d-flex flex-row-reverse"}>
                      <button
                        type="button"
                        onClick={() => {
                          setExportCsv(false);
                          modalDateExportAllMonths();
                        }}
                        className="floatRightBtn btn btn-icon  btn-primary me-2 "
                      >
                        <i className="fa fa-file-pdf-o"></i> Exporter Journal PDF
                      </button>

                      <button
                        type="button"
                        onClick={() => {
                          setExportCsv(true);
                          modalDateExportAllMonths();
                        }}
                        className="floatRightBtn btn btn-icon btn-primary me-2 "
                      >
                        <i className="fa fa-table"></i> Exporter Journal CSV
                      </button>

                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <div style={{ height: "600px", width: "100%" }}>
                    <DataGrid
                      rows={months}
                      density={"compact"}
                      hideFooterPagination={true}
                      columns={columns}
                      initialState={{
                        pagination: {
                          paginationModel: { page: 0, pageSize: 20 },
                        },
                      }}
                      pageSizeOptions={[20]}
                      componentsProps={{
                        toolbar: {
                          csvOptions: { disableToolbarButton: true },
                          printOptions: { disableToolbarButton: true },
                        },
                      }}
                      localeText={
                        i18n.language === "fr"
                          ? frFR.components.MuiDataGrid.defaultProps.localeText
                          : enUS.components.MuiDataGrid.defaultProps.localeText
                      }
                      slotProps={{
                        toolbar: {
                          printOptions: { disableToolbarButton: true },
                          csvOptions: { disableToolbarButton: true },
                        },
                      }}
                      slots={{
                        toolbar: GridToolbar,
                        loadingOverlay: LinearProgress,
                      }}
                      loading={loadingData}
                      onRowSelectionModelChange={(ids) => {
                        setSelectedMonths(ids);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Journal;
